// kapigen version 0.1.33
// eslint-disable
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { google } from "../google";
import { createClient, createRawStringClient } from "../../requestClientInternal";
import { BlobFileWireFormat3 as KaggleSdkBlobsBlobFileWireFormat3 } from "../blobs";
import { HttpRedirectWireFormat3 as KaggleSdkCommonHttpRedirectWireFormat3 } from "../common";
import { OrganizationWireFormat3 as KaggleSdkCompetitionsForeignOrganizationWireFormat3, UserWireFormat3 as KaggleSdkCompetitionsForeignUserWireFormat3 } from "./foreign";
import { EvaluationMetricParameterWireFormat3 as KaggleSdkCompetitionsLegacyEvaluationMetricParameterWireFormat3 } from "./legacy";
import { MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3 } from "../users";
// namespace Kaggle.Sdk.Competitions:
export var CreateSubmissionRequest;
(function(CreateSubmissionRequest) {
    var FileSourceWireFormat3 = CreateSubmissionRequest.FileSourceWireFormat3 = {
        toJson: function toJson(message) {
            return message;
        }
    };
    var KernelSourceWireFormat3 = CreateSubmissionRequest.KernelSourceWireFormat3 = {
        toJson: function toJson(message) {
            return message;
        }
    };
})(CreateSubmissionRequest || (CreateSubmissionRequest = {}));
export var InitiateBulkRerunRequest;
(function(InitiateBulkRerunRequest) {
    var KernelRunSettingsWireFormat3 = InitiateBulkRerunRequest.KernelRunSettingsWireFormat3 = {
        toJson: function toJson(message) {
            var wireFormat = _objectSpread({}, message);
            if ((message === null || message === void 0 ? void 0 : message.maxRamGb) != undefined && (message === null || message === void 0 ? void 0 : message.maxRamGb) != 0) {
                wireFormat.maxRamGb = Number.isFinite(message.maxRamGb) ? message.maxRamGb : Number(message.maxRamGb).toString();
            }
            if ((message === null || message === void 0 ? void 0 : message.maxDiskGb) != undefined && (message === null || message === void 0 ? void 0 : message.maxDiskGb) != 0) {
                wireFormat.maxDiskGb = Number.isFinite(message.maxDiskGb) ? message.maxDiskGb : Number(message.maxDiskGb).toString();
            }
            if ((message === null || message === void 0 ? void 0 : message.maxCpuRuntimeHours) != undefined && (message === null || message === void 0 ? void 0 : message.maxCpuRuntimeHours) != 0) {
                wireFormat.maxCpuRuntimeHours = Number.isFinite(message.maxCpuRuntimeHours) ? message.maxCpuRuntimeHours : Number(message.maxCpuRuntimeHours).toString();
            }
            if ((message === null || message === void 0 ? void 0 : message.maxGpuRuntimeHours) != undefined && (message === null || message === void 0 ? void 0 : message.maxGpuRuntimeHours) != 0) {
                wireFormat.maxGpuRuntimeHours = Number.isFinite(message.maxGpuRuntimeHours) ? message.maxGpuRuntimeHours : Number(message.maxGpuRuntimeHours).toString();
            }
            return wireFormat;
        }
    };
    var RerunSubmissionSelectorWireFormat3 = InitiateBulkRerunRequest.RerunSubmissionSelectorWireFormat3 = {
        toJson: function toJson(message) {
            return message;
        }
    };
})(InitiateBulkRerunRequest || (InitiateBulkRerunRequest = {}));
export var ListCompetitionsRequest;
(function(ListCompetitionsRequest1) {
    var Selector;
    (function(Selector) {
        var ListOption;
        (function(ListOption) {
            ListOption[// Displays launched competitions.
            // (-- KAGGLE_INTERNAL: DateEnabled in the past --)
            "DEFAULT"] = "default";
            ListOption[// Competitions that the current user has entered.
            // (-- KAGGLE_INTERNAL: Specifically, competitions where the user has a
            // team. --)
            "USER_ENTERED"] = "userEntered";
            ListOption[// Competitions that the current user is a host for.
            // (-- KAGGLE_INTERNAL: host-via-admin ignored. --)
            "USER_HOSTED"] = "userHosted";
            ListOption[// Unlaunched competitions.  Must be admin to use this.
            "UNLAUNCHED"] = "unlaunched";
            ListOption[// Displays active competitions.
            // (-- KAGGLE_INTERNAL: date_enabled <= NOW < deadline. --)
            "ACTIVE"] = "active";
            ListOption[// Displays completed competitions
            // (-- KAGGLE_INTERNAL: date_enabled != null && deadline < NOW. --)
            "COMPLETED"] = "completed";
            ListOption[// Displays all competitions in the Current User's Your Work section.
            // (-- KAGGLE_INTERNAL: Complex query combining recent submissions,
            // rules acceptances, and Leaderboard presence. --)
            "USER_YOUR_WORK"] = "userYourWork";
            ListOption[// Displays bookmarked competitions
            "USER_BOOKMARKED"] = "userBookmarked";
            ListOption[// Displays publicly cloneable competitions the user can clone
            "PUBLICLY_CLONEABLE"] = "publiclyCloneable";
        })(ListOption = Selector.ListOption || (Selector.ListOption = {}));
        var ListOptionWireFormat3 = Selector.ListOptionWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case ListOption.DEFAULT:
                    case 0:
                    default:
                        return "LIST_OPTION_DEFAULT";
                    case ListOption.USER_ENTERED:
                    case 1:
                        return "LIST_OPTION_USER_ENTERED";
                    case ListOption.USER_HOSTED:
                    case 2:
                        return "LIST_OPTION_USER_HOSTED";
                    case ListOption.UNLAUNCHED:
                    case 3:
                        return "LIST_OPTION_UNLAUNCHED";
                    case ListOption.ACTIVE:
                    case 4:
                        return "LIST_OPTION_ACTIVE";
                    case ListOption.COMPLETED:
                    case 5:
                        return "LIST_OPTION_COMPLETED";
                    case ListOption.USER_YOUR_WORK:
                    case 6:
                        return "LIST_OPTION_USER_YOUR_WORK";
                    case ListOption.USER_BOOKMARKED:
                    case 7:
                        return "LIST_OPTION_USER_BOOKMARKED";
                    case ListOption.PUBLICLY_CLONEABLE:
                    case 8:
                        return "LIST_OPTION_PUBLICLY_CLONEABLE";
                }
            }
        };
        var ParticipationFilter;
        (function(ParticipationFilter) {
            ParticipationFilter[// Does not add a constraint for visibility.
            "UNSPECIFIED"] = "unspecified";
            ParticipationFilter[// Only returns competitions that anyone is able to join.
            "OPEN"] = "open";
            ParticipationFilter[// Only returns competitions with limited participation.
            "LIMITED"] = "limited";
        })(ParticipationFilter = Selector.ParticipationFilter || (Selector.ParticipationFilter = {}));
        var ParticipationFilterWireFormat3 = Selector.ParticipationFilterWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case ParticipationFilter.UNSPECIFIED:
                    case 0:
                    default:
                        return "PARTICIPATION_FILTER_UNSPECIFIED";
                    case ParticipationFilter.OPEN:
                    case 1:
                        return "PARTICIPATION_FILTER_OPEN";
                    case ParticipationFilter.LIMITED:
                    case 2:
                        return "PARTICIPATION_FILTER_LIMITED";
                }
            }
        };
        var PrestigeFilter;
        (function(PrestigeFilter) {
            PrestigeFilter[// Does not add a constraint for prestige type.
            "UNSPECIFIED"] = "unspecified";
            PrestigeFilter[// Only returns competitions with monetary prizes.
            "MONEY"] = "money";
            PrestigeFilter[// Only returns competitions which award medals.
            "MEDALS"] = "medals";
            PrestigeFilter[// Only returns competitions which do not award money nor medals.
            "OTHER"] = "other";
        })(PrestigeFilter = Selector.PrestigeFilter || (Selector.PrestigeFilter = {}));
        var PrestigeFilterWireFormat3 = Selector.PrestigeFilterWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case PrestigeFilter.UNSPECIFIED:
                    case 0:
                    default:
                        return "PRESTIGE_FILTER_UNSPECIFIED";
                    case PrestigeFilter.MONEY:
                    case 1:
                        return "PRESTIGE_FILTER_MONEY";
                    case PrestigeFilter.MEDALS:
                    case 2:
                        return "PRESTIGE_FILTER_MEDALS";
                    case PrestigeFilter.OTHER:
                    case 3:
                        return "PRESTIGE_FILTER_OTHER";
                }
            }
        };
        var SortOption;
        (function(SortOption) {
            SortOption[// Currently equal to NEWEST.
            "DEFAULT"] = "default";
            SortOption[// Shows the newest competitions first.
            // (-- KAGGLE_INTERNAL: Order by DateEnabled descending. --)
            "NEWEST"] = "newest";
            SortOption[// Shows the oldest competitions first.
            // (-- KAGGLE_INTERNAL: Order by Deadline ascending. --)
            "OLDEST"] = "oldest";
            SortOption[// Sorts by the competition's prize money.
            // (-- KAGGLE_INTERNAL: Orders by RewardQuantity descending. --)
            "REWARD"] = "reward";
            SortOption[// Sorts by the number of teams.
            // (-- KAGGLE_INTERNAL: Order by Comp's (TeamCountOverride ?? TotalTeams)
            // descending. --)
            "NUM_TEAMS"] = "numTeams";
            SortOption[// Shows the recently closed competitions first.
            // (-- KAGGLE_INTERNAL: Order by Deadline descending. --)
            "RECENTLY_CLOSED"] = "recentlyClosed";
        })(SortOption = Selector.SortOption || (Selector.SortOption = {}));
        var SortOptionWireFormat3 = Selector.SortOptionWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case SortOption.DEFAULT:
                    case 0:
                    default:
                        return "SORT_OPTION_DEFAULT";
                    case SortOption.NEWEST:
                    case 1:
                        return "SORT_OPTION_NEWEST";
                    case SortOption.OLDEST:
                    case 2:
                        return "SORT_OPTION_OLDEST";
                    case SortOption.REWARD:
                    case 3:
                        return "SORT_OPTION_REWARD";
                    case SortOption.NUM_TEAMS:
                    case 4:
                        return "SORT_OPTION_NUM_TEAMS";
                    case SortOption.RECENTLY_CLOSED:
                    case 5:
                        return "SORT_OPTION_RECENTLY_CLOSED";
                }
            }
        };
        var VisibilityFilter;
        (function(VisibilityFilter) {
            VisibilityFilter[// Does not add a constraint for visibility.
            "UNSPECIFIED"] = "unspecified";
            VisibilityFilter[// Only returns publicly visible competitions (anonymous users can see).
            "PUBLIC"] = "public";
            VisibilityFilter[// Only returns publicly visible competitions whose Private Leaderboard
            // is also visible.
            "PUBLIC_AND_PRIVATE_LEADERBOARD"] = "publicAndPrivateLeaderboard";
        })(VisibilityFilter = Selector.VisibilityFilter || (Selector.VisibilityFilter = {}));
        var VisibilityFilterWireFormat3 = Selector.VisibilityFilterWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case VisibilityFilter.UNSPECIFIED:
                    case 0:
                    default:
                        return "VISIBILITY_FILTER_UNSPECIFIED";
                    case VisibilityFilter.PUBLIC:
                    case 1:
                        return "VISIBILITY_FILTER_PUBLIC";
                    case VisibilityFilter.PUBLIC_AND_PRIVATE_LEADERBOARD:
                    case 2:
                        return "VISIBILITY_FILTER_PUBLIC_AND_PRIVATE_LEADERBOARD";
                }
            }
        };
    })(Selector = ListCompetitionsRequest1.Selector || (ListCompetitionsRequest1.Selector = {}));
    var SelectorWireFormat3 = ListCompetitionsRequest1.SelectorWireFormat3 = {
        toJson: function toJson(message) {
            var wireFormat = _objectSpread({}, message);
            if (message === null || message === void 0 ? void 0 : message.listOption) {
                wireFormat.listOption = ListCompetitionsRequest.Selector.ListOptionWireFormat3.toJson(message.listOption);
            }
            if (message === null || message === void 0 ? void 0 : message.prestigeFilter) {
                wireFormat.prestigeFilter = ListCompetitionsRequest.Selector.PrestigeFilterWireFormat3.toJson(message.prestigeFilter);
            }
            if (message === null || message === void 0 ? void 0 : message.visibilityFilter) {
                wireFormat.visibilityFilter = ListCompetitionsRequest.Selector.VisibilityFilterWireFormat3.toJson(message.visibilityFilter);
            }
            if (message === null || message === void 0 ? void 0 : message.participationFilter) {
                wireFormat.participationFilter = ListCompetitionsRequest.Selector.ParticipationFilterWireFormat3.toJson(message.participationFilter);
            }
            if (message === null || message === void 0 ? void 0 : message.sortOption) {
                wireFormat.sortOption = ListCompetitionsRequest.Selector.SortOptionWireFormat3.toJson(message.sortOption);
            }
            return wireFormat;
        }
    };
})(ListCompetitionsRequest || (ListCompetitionsRequest = {}));
export var ListSubmissionsRequest;
(function(ListSubmissionsRequest1) {
    var Selector;
    (function(Selector) {
        var ListOption;
        (function(ListOption) {
            ListOption[// List all otherwise matching submissions.
            "DEFAULT"] = "default";
            ListOption[// List only successful submissions.
            "SUCCESSFUL"] = "successful";
            ListOption[// List only selected submissions.
            "SELECTED"] = "selected";
            ListOption[// List only errored submissions.
            "ERROR"] = "error";
        })(ListOption = Selector.ListOption || (Selector.ListOption = {}));
        var ListOptionWireFormat3 = Selector.ListOptionWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case ListOption.DEFAULT:
                    case 0:
                    default:
                        return "LIST_OPTION_DEFAULT";
                    case ListOption.SUCCESSFUL:
                    case 1:
                        return "LIST_OPTION_SUCCESSFUL";
                    case ListOption.SELECTED:
                    case 2:
                        return "LIST_OPTION_SELECTED";
                    case ListOption.ERROR:
                    case 3:
                        return "LIST_OPTION_ERROR";
                }
            }
        };
        var SortOption;
        (function(SortOption) {
            SortOption[// Sort by date submitted, newest submissions first.
            "DEFAULT"] = "default";
            SortOption[// Sort by the name in alphabetical order.
            "NAME"] = "name";
            SortOption[// Sort by the private score, highest score first.
            "PRIVATE_SCORE"] = "privateScore";
            SortOption[// Sort by the public score, highest score first.
            "PUBLIC_SCORE"] = "publicScore";
        })(SortOption = Selector.SortOption || (Selector.SortOption = {}));
        var SortOptionWireFormat3 = Selector.SortOptionWireFormat3 = {
            toJson: function toJson(enumVal) {
                switch(enumVal){
                    case SortOption.DEFAULT:
                    case 0:
                    default:
                        return "SORT_OPTION_DEFAULT";
                    case SortOption.NAME:
                    case 1:
                        return "SORT_OPTION_NAME";
                    case SortOption.PRIVATE_SCORE:
                    case 2:
                        return "SORT_OPTION_PRIVATE_SCORE";
                    case SortOption.PUBLIC_SCORE:
                    case 3:
                        return "SORT_OPTION_PUBLIC_SCORE";
                }
            }
        };
    })(Selector = ListSubmissionsRequest1.Selector || (ListSubmissionsRequest1.Selector = {}));
    var SelectorWireFormat3 = ListSubmissionsRequest1.SelectorWireFormat3 = {
        toJson: function toJson(message) {
            var wireFormat = _objectSpread({}, message);
            if (message === null || message === void 0 ? void 0 : message.listOption) {
                wireFormat.listOption = ListSubmissionsRequest.Selector.ListOptionWireFormat3.toJson(message.listOption);
            }
            if (message === null || message === void 0 ? void 0 : message.sortOption) {
                wireFormat.sortOption = ListSubmissionsRequest.Selector.SortOptionWireFormat3.toJson(message.sortOption);
            }
            return wireFormat;
        }
    };
})(ListSubmissionsRequest || (ListSubmissionsRequest = {}));
export var SearchTeamsResponse;
(function(SearchTeamsResponse) {
    var defaultFoundTeam = {
        teamId: 0,
        teamName: ""
    };
    var FoundTeamWireFormat3 = SearchTeamsResponse.FoundTeamWireFormat3 = {
        fromJson: function fromJson(wireFormat) {
            var message = _objectSpread({}, defaultFoundTeam, wireFormat);
            if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamLeader) {
                message.teamLeader = KaggleSdkCompetitionsForeignUserWireFormat3.fromJson(wireFormat.teamLeader);
            }
            return message;
        }
    };
})(SearchTeamsResponse || (SearchTeamsResponse = {}));
export var UpdateSubmissionSelectionResponse;
(function(UpdateSubmissionSelectionResponse) {
    var ErrorReason;
    (function(ErrorReason) {
        ErrorReason["UNSPECIFIED"] = "unspecified";
        ErrorReason["SELECTIONS_DISABLED"] = "selectionsDisabled";
        ErrorReason["NOT_TEAM_LEADER"] = "notTeamLeader";
        ErrorReason["TOO_MANY_SELECTED"] = "tooManySelected";
        ErrorReason["INVALID_SUBMISSION"] = "invalidSubmission";
        ErrorReason["ALREADY_HAS_VALUE"] = "alreadyHasValue";
    })(ErrorReason = UpdateSubmissionSelectionResponse.ErrorReason || (UpdateSubmissionSelectionResponse.ErrorReason = {}));
})(UpdateSubmissionSelectionResponse || (UpdateSubmissionSelectionResponse = {}));
export var AcceptRulesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var AcceptTeamMergeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultBulkCreateEpisodeRequest = {
    requests: []
};
export var BulkCreateEpisodeRequestWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBulkCreateEpisodeRequest, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.requests) {
            message.requests = wireFormat.requests.map(function(i) {
                return CreateEpisodeRequestWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultBulkCreateEpisodeResponse = {
    episodes: []
};
export var BulkCreateEpisodeResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBulkCreateEpisodeResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.episodes) {
            message.episodes = wireFormat.episodes.map(function(i) {
                return EpisodeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultBulkRerunInfo = {
    id: 0,
    stateCounts: []
};
export var BulkRerunInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBulkRerunInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateInitiated) {
            message.dateInitiated = new Date(wireFormat.dateInitiated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.stateCounts) {
            message.stateCounts = wireFormat.stateCounts.map(function(i) {
                return RerunStateCountWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultBulkRescoreInfo = {
    id: 0,
    stateCounts: []
};
export var BulkRescoreInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBulkRescoreInfo, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateInitiated) {
            message.dateInitiated = new Date(wireFormat.dateInitiated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.stateCounts) {
            message.stateCounts = wireFormat.stateCounts.map(function(i) {
                return RescoreStateCountWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var CancelBulkRerunRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CancelBulkRescoreRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCancelBulkRescoreResponse = {
    numCanceled: 0
};
export var CancelBulkRescoreResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCancelBulkRescoreResponse, wireFormat);
        return message;
    }
};
export var CanSubmitRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.createRequest) {
            wireFormat.createRequest = CreateSubmissionRequestWireFormat3.toJson(message.createRequest);
        }
        return wireFormat;
    }
};
var defaultCanSubmitResponse = {
    canSubmit: false,
    notAllowedReasons: [],
    requiredFileName: ""
};
export var CanSubmitResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCanSubmitResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notAllowedReasons) {
            message.notAllowedReasons = wireFormat.notAllowedReasons.map(function(i) {
                return SubmissionNotAllowedReasonWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissionLimitInfo) {
            message.submissionLimitInfo = SubmissionLimitInfoWireFormat3.fromJson(wireFormat.submissionLimitInfo);
        }
        return message;
    }
};
export var ClearLeaderboardSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultClearLeaderboardSubmissionsResponse = {
    submissionsCleared: 0
};
export var ClearLeaderboardSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultClearLeaderboardSubmissionsResponse, wireFormat);
        return message;
    }
};
var defaultCompetition = {
    id: 0,
    competitionName: "",
    title: "",
    briefDescription: "",
    leaderboardPercentage: 0,
    maxDailySubmissions: 0,
    numScoredSubmissions: 0,
    hasSolution: false,
    finalLeaderboardHasBeenVerified: false,
    disableSubmissions: false,
    isPrivate: false,
    userRankMultiplier: 0,
    limitedParticipationGroupId: 0,
    witholdFinalLeaderboardUntilItHasBeenVerified: false,
    rewardTypeId: 0,
    rewardQuantity: 0,
    publicLeaderboardDisclaimerMessage: "",
    finalLeaderboardDisclaimerMessage: "",
    competitionHostSegmentId: 0,
    maxTeamSize: 0,
    prohibitNewEntrants: false,
    medalsAllowed: false,
    enableTeamModels: false,
    prohibitSolutionDownload: false,
    totalSolutionRows: 0,
    organizationId: 0,
    thumbnailImageUrl: "",
    coverImageUrl: "",
    cardImageUrl: "",
    showPrivateLeaderboard: false,
    isTeamCountOverridden: false,
    hasScripts: false,
    shareToken: "",
    onlyAllowKernelSubmissions: false,
    totalTeams: 0,
    rulesRequired: false,
    usesSynchronousReruns: false,
    postProcessorKernelId: 0,
    disableKernelsPublishing: false,
    userBookmarked: false,
    launched: false,
    restrictLinkToEmailList: false
};
export var CompetitionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetition, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateEnabled) {
            message.dateEnabled = new Date(wireFormat.dateEnabled);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userRankMultiplier) != undefined) {
            message.userRankMultiplier = Number(wireFormat.userRankMultiplier);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.rewardQuantity) != undefined) {
            message.rewardQuantity = Number(wireFormat.rewardQuantity);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateCreated) {
            message.dateCreated = new Date(wireFormat.dateCreated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamModelDeadline) {
            message.teamModelDeadline = new Date(wireFormat.teamModelDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamMergerExplicitDeadline) {
            message.teamMergerExplicitDeadline = new Date(wireFormat.teamMergerExplicitDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.prohibitNewEntrantsExplicitDeadline) {
            message.prohibitNewEntrantsExplicitDeadline = new Date(wireFormat.prohibitNewEntrantsExplicitDeadline);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLeaderboardReleaseDate) {
            message.privateLeaderboardReleaseDate = new Date(wireFormat.privateLeaderboardReleaseDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationAlgorithm) {
            message.evaluationAlgorithm = EvaluationAlgorithmWireFormat3.fromJson(wireFormat.evaluationAlgorithm);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.organization) {
            message.organization = KaggleSdkCompetitionsForeignOrganizationWireFormat3.fromJson(wireFormat.organization);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionMetricVersion) {
            message.competitionMetricVersion = CompetitionMetricVersionWireFormat3.fromJson(wireFormat.competitionMetricVersion);
        }
        if (wireFormat) {
            message.publiclyCloneable = PubliclyCloneableWireFormat3.fromJson(wireFormat.publiclyCloneable);
        }
        return message;
    }
};
var defaultCompetitionEmail = {
    emailBody: "",
    totalEmailsSent: 0
};
export var CompetitionEmailWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionEmail, wireFormat);
        return message;
    }
};
var defaultCompetitionEmailInvite = {
    id: 0,
    emailAddress: ""
};
export var CompetitionEmailInviteWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionEmailInvite, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.creationTime) {
            message.creationTime = new Date(wireFormat.creationTime);
        }
        return message;
    }
};
var defaultCompetitionKernelRerunState = {};
export var CompetitionKernelRerunStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionKernelRerunState, wireFormat);
        if (wireFormat) {
            message.id = RerunStateWireFormat3.fromJson(wireFormat.id);
        }
        if (wireFormat) {
            message.name = RerunStateNameWireFormat3.fromJson(wireFormat.name);
        }
        if (wireFormat) {
            message.errorCause = RerunStateErrorCauseWireFormat3.fromJson(wireFormat.errorCause);
        }
        if (wireFormat) {
            message.sourceSubmissionStatus = SubmissionStatusWireFormat3.fromJson(wireFormat.sourceSubmissionStatus);
        }
        return message;
    }
};
var defaultCompetitionMetricMetadata = {};
export var CompetitionMetricMetadataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionMetricMetadata, wireFormat);
        if (wireFormat) {
            message.subCategory = CompetitionMetricSubCategoryWireFormat3.fromJson(wireFormat.subCategory);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.subCategory) {
            wireFormat.subCategory = CompetitionMetricSubCategoryWireFormat3.toJson(message.subCategory);
        }
        return wireFormat;
    }
};
var defaultCompetitionMetricVersion = {
    id: 0,
    sourceKernelSessionId: 0
};
export var CompetitionMetricVersionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionMetricVersion, wireFormat);
        return message;
    }
};
var defaultCompetitionNotebook = {
    submissionId: 0,
    title: "",
    kernelRunId: 0,
    authorUserName: "",
    slug: ""
};
export var CompetitionNotebookWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCompetitionNotebook, wireFormat);
        return message;
    }
};
export var CreateCompetitionEmailInvitesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateCompetitionEmailInvitesResponse = {
    emailInvites: []
};
export var CreateCompetitionEmailInvitesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateCompetitionEmailInvitesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.emailInvites) {
            message.emailInvites = wireFormat.emailInvites.map(function(i) {
                return CompetitionEmailInviteWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var CreateCompetitionMetricRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateCompetitionMetricResponse = {};
export var CreateCompetitionMetricResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateCompetitionMetricResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.httpRedirect) {
            message.httpRedirect = KaggleSdkCommonHttpRedirectWireFormat3.fromJson(wireFormat.httpRedirect);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.evaluationAlgorithm) {
            message.evaluationAlgorithm = EvaluationAlgorithmWireFormat3.fromJson(wireFormat.evaluationAlgorithm);
        }
        return message;
    }
};
export var CreateCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.hostSegment) {
            wireFormat.hostSegment = HostSegmentWireFormat3.toJson(message.hostSegment);
        }
        if (message === null || message === void 0 ? void 0 : message.privacy) {
            wireFormat.privacy = CompetitionPrivacyWireFormat3.toJson(message.privacy);
        }
        return wireFormat;
    }
};
var defaultCreateCompetitionResponse = {};
export var CreateCompetitionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateCompetitionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competition) {
            message.competition = CompetitionWireFormat3.fromJson(wireFormat.competition);
        }
        return message;
    }
};
export var CreateCompetitionSampleSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateCompetitionSolutionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateEnvironmentMetricRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.renderType) {
            wireFormat.renderType = EnvironmentRenderTypeWireFormat3.toJson(message.renderType);
        }
        return wireFormat;
    }
};
var defaultCreateEpisodeRequest = {
    submissionIds: []
};
export var CreateEpisodeRequestWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateEpisodeRequest, wireFormat);
        if (wireFormat) {
            message.type = EpisodeTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
export var CreatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.page) {
            wireFormat.page = PageWireFormat3.toJson(message.page);
        }
        return wireFormat;
    }
};
export var CreateSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.kernelSource) {
            wireFormat.kernelSource = CreateSubmissionRequest.KernelSourceWireFormat3.toJson(message.kernelSource);
        }
        if (message === null || message === void 0 ? void 0 : message.fileSource) {
            wireFormat.fileSource = CreateSubmissionRequest.FileSourceWireFormat3.toJson(message.fileSource);
        }
        return wireFormat;
    }
};
export var CreateTeamModelFileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateTeamModelFileResponse = {
    fileName: "",
    sizeBytes: 0
};
export var CreateTeamModelFileResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateTeamModelFileResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.sizeBytes) {
            message.sizeBytes = parseInt(wireFormat.sizeBytes);
        }
        return message;
    }
};
var defaultCreateTeamsInfo = {
    id: 0,
    name: "",
    leaderId: 0,
    memberIds: []
};
export var CreateTeamsInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateTeamsInfo, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
export var CreateTeamsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.teams) {
            wireFormat.teams = message.teams.map(function(i) {
                return CreateTeamsInfoWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultCreateTeamsResponse = {
    teams: []
};
export var CreateTeamsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateTeamsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return CreateTeamsInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var DeleteCompetitionEmailInviteRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteCompetitionEmailInviteResponse = {};
export var DeleteCompetitionEmailInviteResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteCompetitionEmailInviteResponse, wireFormat);
        return message;
    }
};
export var DeleteCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteCompetitionResponse = {};
export var DeleteCompetitionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteCompetitionResponse, wireFormat);
        return message;
    }
};
export var DeletePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteSolutionFilesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DownloadTeamModelFileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDownloadTeamModelFileResponse = {
    downloadUrl: ""
};
export var DownloadTeamModelFileResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDownloadTeamModelFileResponse, wireFormat);
        return message;
    }
};
export var EmailParticipantsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.userFilter) {
            wireFormat.userFilter = UserFilterWireFormat3.toJson(message.userFilter);
        }
        return wireFormat;
    }
};
var defaultEpisode = {
    id: 0,
    agents: []
};
export var EpisodeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEpisode, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.endTime) {
            message.endTime = new Date(wireFormat.endTime);
        }
        if (wireFormat) {
            message.type = EpisodeTypeWireFormat3.fromJson(wireFormat.type);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.agents) {
            message.agents = wireFormat.agents.map(function(i) {
                return EpisodeAgentWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultEpisodeAgent = {
    id: 0,
    submissionId: 0,
    index: 0
};
export var EpisodeAgentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEpisodeAgent, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.reward) != undefined) {
            message.reward = Number(wireFormat.reward);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.initialScore) != undefined) {
            message.initialScore = Number(wireFormat.initialScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.updatedScore) != undefined) {
            message.updatedScore = Number(wireFormat.updatedScore);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
            message.submission = SubmissionWireFormat3.fromJson(wireFormat.submission);
        }
        return message;
    }
};
var defaultEvaluationAlgorithm = {
    name: "",
    isMax: false,
    isEnvironment: false
};
export var EvaluationAlgorithmWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultEvaluationAlgorithm, wireFormat);
        if (wireFormat) {
            message.environmentRenderType = EnvironmentRenderTypeWireFormat3.fromJson(wireFormat.environmentRenderType);
        }
        if (wireFormat) {
            message.state = EvaluationAlgorithmStateWireFormat3.fromJson(wireFormat.state);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.latestCompetitionMetricVersion) {
            message.latestCompetitionMetricVersion = CompetitionMetricVersionWireFormat3.fromJson(wireFormat.latestCompetitionMetricVersion);
        }
        return message;
    }
};
export var GenerateEpisodesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGenerateEpisodesResponse = {};
export var GenerateEpisodesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGenerateEpisodesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bulkCreateEpisodeRequest) {
            message.bulkCreateEpisodeRequest = BulkCreateEpisodeRequestWireFormat3.fromJson(wireFormat.bulkCreateEpisodeRequest);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bulkCreateEpisodeResponse) {
            message.bulkCreateEpisodeResponse = BulkCreateEpisodeResponseWireFormat3.fromJson(wireFormat.bulkCreateEpisodeResponse);
        }
        return message;
    }
};
export var GetCompetitionCitationRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCompetitionCitationResponse = {
    bibTex: "",
    singleLineCitation: ""
};
export var GetCompetitionCitationResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionCitationResponse, wireFormat);
        return message;
    }
};
export var GetCompetitionDatabundleVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.competitionDatabundleType) {
            wireFormat.competitionDatabundleType = CompetitionDatabundleTypeWireFormat3.toJson(message.competitionDatabundleType);
        }
        return wireFormat;
    }
};
var defaultGetCompetitionDatabundleVersionResponse = {
    databundleVersionId: 0
};
export var GetCompetitionDatabundleVersionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionDatabundleVersionResponse, wireFormat);
        return message;
    }
};
export var GetCompetitionMetricMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCompetitionMetricMetadataResponse = {};
export var GetCompetitionMetricMetadataResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionMetricMetadataResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metadata) {
            message.metadata = CompetitionMetricMetadataWireFormat3.fromJson(wireFormat.metadata);
        }
        return message;
    }
};
export var GetCompetitionMetricVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCompetitionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetCompetitionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetCompetitionsResponse = {
    competitions: []
};
export var GetCompetitionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetCompetitionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitions) {
            message.competitions = wireFormat.competitions.map(function(i) {
                return CompetitionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetEpisodeReplayRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetLeaderboardRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.leaderboardMode) {
            wireFormat.leaderboardMode = LeaderboardModeWireFormat3.toJson(message.leaderboardMode);
        }
        return wireFormat;
    }
};
var defaultGetLeaderboardResponse = {
    publicLeaderboard: [],
    privateLeaderboard: [],
    teams: []
};
export var GetLeaderboardResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetLeaderboardResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicLeaderboard) {
            message.publicLeaderboard = wireFormat.publicLeaderboard.map(function(i) {
                return LeaderboardEntryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLeaderboard) {
            message.privateLeaderboard = wireFormat.privateLeaderboard.map(function(i) {
                return LeaderboardEntryWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return LeaderboardTeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetPageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.page) {
            wireFormat.page = PageByNameWireFormat3.toJson(message.page);
        }
        return wireFormat;
    }
};
export var GetPrivacySettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetProfileUserStatsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetProfileUserStatsResponse = {
    competitionsCount: 0,
    soloCompetitionsCount: 0,
    teamCompetitionsCount: 0
};
export var GetProfileUserStatsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetProfileUserStatsResponse, wireFormat);
        return message;
    }
};
export var GetRanksForUsersRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetRanksForUsersResponse = {
    userRanks: {}
};
export var GetRanksForUsersResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetRanksForUsersResponse, wireFormat);
        return message;
    }
};
export var GetSubmissionLimitInfoRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetTeamModelFileRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetTeamRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var GetUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetUserResponse = {
    isAdmin: false,
    isPhoneVerified: false,
    hasAcceptedRules: false,
    isHost: false,
    canParticipate: false
};
export var GetUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetUserResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.user) {
            message.user = KaggleSdkCompetitionsForeignUserWireFormat3.fromJson(wireFormat.user);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.team) {
            message.team = TeamWireFormat3.fromJson(wireFormat.team);
        }
        return message;
    }
};
export var HasAcceptedRulesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultHasAcceptedRulesResponse = {
    hasAccepted: false
};
export var HasAcceptedRulesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHasAcceptedRulesResponse, wireFormat);
        return message;
    }
};
export var HasCompetitionEmailInviteRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultHasCompetitionEmailInviteResponse = {
    hasEmailInvite: false
};
export var HasCompetitionEmailInviteResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHasCompetitionEmailInviteResponse, wireFormat);
        return message;
    }
};
export var InitiateBulkRerunRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.submissionSelector) {
            wireFormat.submissionSelector = InitiateBulkRerunRequest.RerunSubmissionSelectorWireFormat3.toJson(message.submissionSelector);
        }
        if (message === null || message === void 0 ? void 0 : message.kernelRunSettings) {
            wireFormat.kernelRunSettings = InitiateBulkRerunRequest.KernelRunSettingsWireFormat3.toJson(message.kernelRunSettings);
        }
        return wireFormat;
    }
};
var defaultInitiateBulkRerunResponse = {
    numCreated: 0
};
export var InitiateBulkRerunResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultInitiateBulkRerunResponse, wireFormat);
        return message;
    }
};
export var InitiateBulkRescoreRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.rescoreType) {
            wireFormat.rescoreType = RescoreTypeWireFormat3.toJson(message.rescoreType);
        }
        return wireFormat;
    }
};
var defaultInitiateBulkRescoreResponse = {
    numInitiated: 0
};
export var InitiateBulkRescoreResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultInitiateBulkRescoreResponse, wireFormat);
        return message;
    }
};
export var InvalidateSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultLeaderboardEntry = {
    teamId: 0,
    submissionId: 0,
    rank: 0,
    displayScore: "",
    inTheMoney: false,
    rankDelta: 0
};
export var LeaderboardEntryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLeaderboardEntry, wireFormat);
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        return message;
    }
};
var defaultLeaderboardTeam = {
    teamId: 0,
    teamName: "",
    isBenchmark: false,
    submissionCount: 0,
    teamUpEnabled: false,
    teamMembers: []
};
export var LeaderboardTeamWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLeaderboardTeam, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastSubmissionDate) {
            message.lastSubmissionDate = new Date(wireFormat.lastSubmissionDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamMembers) {
            message.teamMembers = wireFormat.teamMembers.map(function(i) {
                return KaggleSdkCompetitionsForeignUserWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var LegacyRecalculateLeaderboardRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultLegacyRecalculateLeaderboardResponse = {
    rowsAffected: 0
};
export var LegacyRecalculateLeaderboardResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultLegacyRecalculateLeaderboardResponse, wireFormat);
        return message;
    }
};
export var ListBulkRerunsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListBulkRerunsResponse = {
    bulkReruns: []
};
export var ListBulkRerunsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListBulkRerunsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bulkReruns) {
            message.bulkReruns = wireFormat.bulkReruns.map(function(i) {
                return BulkRerunInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListBulkRescoresRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListBulkRescoresResponse = {
    bulkRescores: []
};
export var ListBulkRescoresResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListBulkRescoresResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.bulkRescores) {
            message.bulkRescores = wireFormat.bulkRescores.map(function(i) {
                return BulkRescoreInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListCompetitionEmailInvitesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListCompetitionEmailInvitesResponse = {
    emailInvites: []
};
export var ListCompetitionEmailInvitesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCompetitionEmailInvitesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.emailInvites) {
            message.emailInvites = wireFormat.emailInvites.map(function(i) {
                return CompetitionEmailInviteWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListCompetitionMetricsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.authorType) {
            wireFormat.authorType = MetricListAuthorTypeWireFormat3.toJson(message.authorType);
        }
        if (message === null || message === void 0 ? void 0 : message.sortType) {
            wireFormat.sortType = MetricListSortTypeWireFormat3.toJson(message.sortType);
        }
        if (message === null || message === void 0 ? void 0 : message.category) {
            wireFormat.category = CompetitionMetricSubCategoryWireFormat3.toJson(message.category);
        }
        if (message === null || message === void 0 ? void 0 : message.language) {
            wireFormat.language = MetricLanguageWireFormat3.toJson(message.language);
        }
        return wireFormat;
    }
};
var defaultListCompetitionMetricsResponse = {
    metrics: [],
    totalResults: 0
};
export var ListCompetitionMetricsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCompetitionMetricsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metrics) {
            message.metrics = wireFormat.metrics.map(function(i) {
                return MetricInfoWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListCompetitionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.selector) {
            wireFormat.selector = ListCompetitionsRequest.SelectorWireFormat3.toJson(message.selector);
        }
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultListCompetitionsResponse = {
    competitions: [],
    userTeams: [],
    teamSubmissionLimitInfos: {},
    teamRanks: {},
    nextPageToken: "",
    totalResults: 0
};
export var ListCompetitionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListCompetitionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitions) {
            message.competitions = wireFormat.competitions.map(function(i) {
                return CompetitionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.userTeams) {
            message.userTeams = wireFormat.userTeams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamSubmissionLimitInfos) {
            message.teamSubmissionLimitInfos = {};
            Object.entries(wireFormat.teamSubmissionLimitInfos).forEach(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                message.teamSubmissionLimitInfos[key] = SubmissionLimitInfoWireFormat3.fromJson(value);
            });
        }
        return message;
    }
};
export var ListEpisodesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListEpisodesResponse = {
    episodes: [],
    submissions: [],
    teams: []
};
export var ListEpisodesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListEpisodesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.episodes) {
            message.episodes = wireFormat.episodes.map(function(i) {
                return EpisodeWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissions) {
            message.submissions = wireFormat.submissions.map(function(i) {
                return SubmissionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListPagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListPagesResponse = {
    pages: []
};
export var ListPagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListPagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.pages) {
            message.pages = wireFormat.pages.map(function(i) {
                return PageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListSubmissionsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.selector) {
            wireFormat.selector = ListSubmissionsRequest.SelectorWireFormat3.toJson(message.selector);
        }
        return wireFormat;
    }
};
var defaultListSubmissionsResponse = {
    submissions: [],
    nextPageToken: "",
    notebooks: [],
    privateEligibleSubmissions: []
};
export var ListSubmissionsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListSubmissionsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submissions) {
            message.submissions = wireFormat.submissions.map(function(i) {
                return SubmissionWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.notebooks) {
            message.notebooks = wireFormat.notebooks.map(function(i) {
                return CompetitionNotebookWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateEligibleSubmissions) {
            message.privateEligibleSubmissions = wireFormat.privateEligibleSubmissions.map(function(i) {
                return SubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListTeamMergeRequestsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTeamMergeRequestsResponse = {
    inbound: [],
    outbound: []
};
export var ListTeamMergeRequestsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTeamMergeRequestsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.inbound) {
            message.inbound = wireFormat.inbound.map(function(i) {
                return TeamMergeRequestWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.outbound) {
            message.outbound = wireFormat.outbound.map(function(i) {
                return TeamMergeRequestWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListTeamsByUserRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTeamsByUserResponse = {
    teams: []
};
export var ListTeamsByUserResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTeamsByUserResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var ListTeamsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTeamsResponse = {
    teams: []
};
export var ListTeamsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTeamsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultMetricInfo = {
    id: 0,
    name: ""
};
export var MetricInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultMetricInfo, wireFormat);
        if (wireFormat) {
            message.language = MetricLanguageWireFormat3.fromJson(wireFormat.language);
        }
        if (wireFormat) {
            message.category = CompetitionMetricSubCategoryWireFormat3.fromJson(wireFormat.category);
        }
        return message;
    }
};
var defaultPage = {
    id: 0,
    competitionId: 0,
    name: "",
    content: "",
    mimeType: "",
    isPublished: false,
    order: 0,
    postTitle: ""
};
export var PageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPage, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
export var PageByNameWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultPrivacySettings = {
    shareToken: "",
    restrictToEmailList: false
};
export var PrivacySettingsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPrivacySettings, wireFormat);
        if (wireFormat) {
            message.privacy = CompetitionPrivacyWireFormat3.fromJson(wireFormat.privacy);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.privacy) {
            wireFormat.privacy = CompetitionPrivacyWireFormat3.toJson(message.privacy);
        }
        return wireFormat;
    }
};
export var PublishBulkRerunRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RecalculateLeaderboardRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.leaderboardMode) {
            wireFormat.leaderboardMode = LeaderboardModeWireFormat3.toJson(message.leaderboardMode);
        }
        return wireFormat;
    }
};
var defaultRecalculateLeaderboardResponse = {
    weakUpdatedTeams: [],
    strongUpdatedTeams: []
};
export var RecalculateLeaderboardResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRecalculateLeaderboardResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.weakUpdatedTeams) {
            message.weakUpdatedTeams = wireFormat.weakUpdatedTeams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.strongUpdatedTeams) {
            message.strongUpdatedTeams = wireFormat.strongUpdatedTeams.map(function(i) {
                return TeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var RegenerateShareTokenRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RejectTeamMergeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var RequestTeamMergeRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultRerunStateCount = {
    count: 0
};
export var RerunStateCountWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRerunStateCount, wireFormat);
        if (wireFormat) {
            message.name = RerunStateNameWireFormat3.fromJson(wireFormat.name);
        }
        return message;
    }
};
var defaultRescoreStateCount = {
    count: 0
};
export var RescoreStateCountWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultRescoreStateCount, wireFormat);
        if (wireFormat) {
            message.state = RescoreStateWireFormat3.fromJson(wireFormat.state);
        }
        return message;
    }
};
export var RescoreSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var SearchTeamsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchTeamsResponse = {
    teams: []
};
export var SearchTeamsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchTeamsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teams) {
            message.teams = wireFormat.teams.map(function(i) {
                return SearchTeamsResponse.FoundTeamWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SetCompetitionDeadlineNowRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSetCompetitionDeadlineNowResponse = {};
export var SetCompetitionDeadlineNowResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSetCompetitionDeadlineNowResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.deadline) {
            message.deadline = new Date(wireFormat.deadline);
        }
        return message;
    }
};
export var SetCompetitionMetricRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSetCompetitionMetricResponse = {};
export var SetCompetitionMetricResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSetCompetitionMetricResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.metric) {
            message.metric = EvaluationAlgorithmWireFormat3.fromJson(wireFormat.metric);
        }
        return message;
    }
};
export var SetEpisodeErroredRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSubmission = {
    id: 0,
    title: "",
    details: "",
    submittedUserId: 0,
    teamId: 0,
    isSelected: false,
    isAfterDeadline: false,
    processingDetails: "",
    contentLength: 0,
    syncRerunId: 0
};
export var SubmissionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSubmission, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateSubmitted) {
            message.dateSubmitted = new Date(wireFormat.dateSubmitted);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateScore) != undefined) {
            message.privateScore = Number(wireFormat.privateScore);
        }
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicScore) != undefined) {
            message.publicScore = Number(wireFormat.publicScore);
        }
        if (wireFormat) {
            message.status = SubmissionStatusWireFormat3.fromJson(wireFormat.status);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.team) {
            message.team = TeamWireFormat3.fromJson(wireFormat.team);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.syncRerunState) {
            message.syncRerunState = CompetitionKernelRerunStateWireFormat3.fromJson(wireFormat.syncRerunState);
        }
        return message;
    }
};
var defaultSubmissionLimitInfo = {
    numToday: 0,
    numTotal: 0,
    limitedByTotal: false
};
export var SubmissionLimitInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSubmissionLimitInfo, wireFormat);
        return message;
    }
};
var defaultSubmissionNotAllowedReason = {
    message: ""
};
export var SubmissionNotAllowedReasonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSubmissionNotAllowedReason, wireFormat);
        if (wireFormat) {
            message.code = SubmissionNotAllowedReasonCodeWireFormat3.fromJson(wireFormat.code);
        }
        return message;
    }
};
var defaultTeam = {
    id: 0,
    teamName: "",
    competitionId: 0,
    teamLeaderId: 0,
    medal: 0,
    teamUpEnabled: false,
    teamMembers: []
};
export var TeamWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTeam, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competition) {
            message.competition = CompetitionWireFormat3.fromJson(wireFormat.competition);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.teamMembers) {
            message.teamMembers = wireFormat.teamMembers.map(function(i) {
                return KaggleSdkCompetitionsForeignUserWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultTeamMergeRequest = {
    id: 0,
    childTeamId: 0,
    parentTeamId: 0
};
export var TeamMergeRequestWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTeamMergeRequest, wireFormat);
        if (wireFormat) {
            message.state = TeamMergeRequestStateWireFormat3.fromJson(wireFormat.state);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateInitiated) {
            message.dateInitiated = new Date(wireFormat.dateInitiated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.dateUpdated) {
            message.dateUpdated = new Date(wireFormat.dateUpdated);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.childTeam) {
            message.childTeam = TeamWireFormat3.fromJson(wireFormat.childTeam);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parentTeam) {
            message.parentTeam = TeamWireFormat3.fromJson(wireFormat.parentTeam);
        }
        return message;
    }
};
var defaultTeamModelFile = {};
export var TeamModelFileWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTeamModelFile, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blobFile) {
            message.blobFile = KaggleSdkBlobsBlobFileWireFormat3.fromJson(wireFormat.blobFile);
        }
        return message;
    }
};
export var ToggleBenchmarkSubmissionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateCompetitionMetricMetadataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.metadata) {
            wireFormat.metadata = CompetitionMetricMetadataWireFormat3.toJson(message.metadata);
        }
        return wireFormat;
    }
};
export var UpdateCurrentCompetitionMetricVersionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateCurrentCompetitionMetricVersionResponse = {
    parameters: []
};
export var UpdateCurrentCompetitionMetricVersionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateCurrentCompetitionMetricVersionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.competitionMetricVersion) {
            message.competitionMetricVersion = CompetitionMetricVersionWireFormat3.fromJson(wireFormat.competitionMetricVersion);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parameters) {
            message.parameters = wireFormat.parameters.map(function(i) {
                return KaggleSdkCompetitionsLegacyEvaluationMetricParameterWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdatePageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.page) {
            wireFormat.page = PageWireFormat3.toJson(message.page);
        }
        if (message === null || message === void 0 ? void 0 : message.updateMask) {
            var _paths;
            wireFormat.updateMask = ((_paths = message.updateMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
export var UpdatePrivacySettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.privacySettings) {
            wireFormat.privacySettings = PrivacySettingsWireFormat3.toJson(message.privacySettings);
        }
        return wireFormat;
    }
};
export var UpdateSandboxSubmissionNameRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateSubmissionDescriptionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var UpdateSubmissionSelectionRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateSubmissionSelectionResponse = {
    privateEligibleSubmissions: []
};
export var UpdateSubmissionSelectionResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateSubmissionSelectionResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.submission) {
            message.submission = SubmissionWireFormat3.fromJson(wireFormat.submission);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateEligibleSubmissions) {
            message.privateEligibleSubmissions = wireFormat.privateEligibleSubmissions.map(function(i) {
                return SubmissionWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateTeamRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var WaitForCompetitionAdminEvaluationEventRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.waitEvent) {
            wireFormat.waitEvent = CompetitionAdminEvaluationEventWireFormat3.toJson(message.waitEvent);
        }
        return wireFormat;
    }
};
var defaultWaitForCompetitionAdminEvaluationEventResponse = {
    errorMessage: ""
};
export var WaitForCompetitionAdminEvaluationEventResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultWaitForCompetitionAdminEvaluationEventResponse, wireFormat);
        if (wireFormat) {
            message.status = CompetitionAdminEvaluationEventStatusWireFormat3.fromJson(wireFormat.status);
        }
        return message;
    }
};
export var CompetitionAdminEvaluationEvent;
(function(CompetitionAdminEvaluationEvent) {
    CompetitionAdminEvaluationEvent["UNSPECIFIED"] = "unspecified";
    CompetitionAdminEvaluationEvent["SOLUTION_COLUMN_MAPPING_CREATED"] = "solutionColumnMappingCreated";
    CompetitionAdminEvaluationEvent["SOLUTION_SAMPLED"] = "solutionSampled";
    CompetitionAdminEvaluationEvent["SUBMISSION_COLUMN_MAPPING_CREATED"] = "submissionColumnMappingCreated";
})(CompetitionAdminEvaluationEvent || (CompetitionAdminEvaluationEvent = {}));
export var CompetitionAdminEvaluationEventWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionAdminEvaluationEvent.UNSPECIFIED:
            case 0:
            default:
                return "COMPETITION_ADMIN_EVALUATION_EVENT_UNSPECIFIED";
            case CompetitionAdminEvaluationEvent.SOLUTION_COLUMN_MAPPING_CREATED:
            case 1:
                return "COMPETITION_ADMIN_EVALUATION_EVENT_SOLUTION_COLUMN_MAPPING_CREATED";
            case CompetitionAdminEvaluationEvent.SOLUTION_SAMPLED:
            case 2:
                return "COMPETITION_ADMIN_EVALUATION_EVENT_SOLUTION_SAMPLED";
            case CompetitionAdminEvaluationEvent.SUBMISSION_COLUMN_MAPPING_CREATED:
            case 3:
                return "COMPETITION_ADMIN_EVALUATION_EVENT_SUBMISSION_COLUMN_MAPPING_CREATED";
        }
    }
};
export var CompetitionAdminEvaluationEventStatus;
(function(CompetitionAdminEvaluationEventStatus) {
    CompetitionAdminEvaluationEventStatus["UNSPECIFIED"] = "unspecified";
    CompetitionAdminEvaluationEventStatus["COMPLETED"] = "completed";
    CompetitionAdminEvaluationEventStatus["ERROR"] = "error";
    CompetitionAdminEvaluationEventStatus["TIMED_OUT"] = "timedOut";
})(CompetitionAdminEvaluationEventStatus || (CompetitionAdminEvaluationEventStatus = {}));
export var CompetitionAdminEvaluationEventStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COMPETITION_ADMIN_EVALUATION_EVENT_STATUS_UNSPECIFIED":
            default:
                return CompetitionAdminEvaluationEventStatus.UNSPECIFIED;
            case "COMPETITION_ADMIN_EVALUATION_EVENT_STATUS_COMPLETED":
                return CompetitionAdminEvaluationEventStatus.COMPLETED;
            case "COMPETITION_ADMIN_EVALUATION_EVENT_STATUS_ERROR":
                return CompetitionAdminEvaluationEventStatus.ERROR;
            case "COMPETITION_ADMIN_EVALUATION_EVENT_STATUS_TIMED_OUT":
                return CompetitionAdminEvaluationEventStatus.TIMED_OUT;
        }
    }
};
export var CompetitionDatabundleType;
(function(CompetitionDatabundleType) {
    CompetitionDatabundleType["UNSPECIFIED"] = "unspecified";
    CompetitionDatabundleType["PUBLIC"] = "public";
    CompetitionDatabundleType["RERUN"] = "rerun";
})(CompetitionDatabundleType || (CompetitionDatabundleType = {}));
export var CompetitionDatabundleTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionDatabundleType.UNSPECIFIED:
            case 0:
            default:
                return "COMPETITION_DATABUNDLE_TYPE_UNSPECIFIED";
            case CompetitionDatabundleType.PUBLIC:
            case 1:
                return "COMPETITION_DATABUNDLE_TYPE_PUBLIC";
            case CompetitionDatabundleType.RERUN:
            case 2:
                return "COMPETITION_DATABUNDLE_TYPE_RERUN";
        }
    }
};
export var CompetitionError;
(function(CompetitionError) {
    CompetitionError["UNSPECIFIED"] = "unspecified";
    CompetitionError[// User needs to accept the rules of a competition.
    "RULES_ACCEPTANCE_REQUIRED"] = "rulesAcceptanceRequired";
    CompetitionError[// Competition does not allow new entrants.
    "NEW_ENTRANTS_NOT_ALLOWED"] = "newEntrantsNotAllowed";
})(CompetitionError || (CompetitionError = {}));
export var CompetitionMetricSubCategory;
(function(CompetitionMetricSubCategory) {
    CompetitionMetricSubCategory["UNSPECIFIED"] = "unspecified";
    CompetitionMetricSubCategory["CLASSIFICATION"] = "classification";
    CompetitionMetricSubCategory["REGRESSION"] = "regression";
    CompetitionMetricSubCategory["CLUSTERING"] = "clustering";
    CompetitionMetricSubCategory["OBJECT_DETECTION"] = "objectDetection";
    CompetitionMetricSubCategory["OTHER"] = "other";
})(CompetitionMetricSubCategory || (CompetitionMetricSubCategory = {}));
export var CompetitionMetricSubCategoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COMPETITION_METRIC_SUB_CATEGORY_UNSPECIFIED":
            default:
                return CompetitionMetricSubCategory.UNSPECIFIED;
            case "COMPETITION_METRIC_SUB_CATEGORY_CLASSIFICATION":
                return CompetitionMetricSubCategory.CLASSIFICATION;
            case "COMPETITION_METRIC_SUB_CATEGORY_REGRESSION":
                return CompetitionMetricSubCategory.REGRESSION;
            case "COMPETITION_METRIC_SUB_CATEGORY_CLUSTERING":
                return CompetitionMetricSubCategory.CLUSTERING;
            case "COMPETITION_METRIC_SUB_CATEGORY_OBJECT_DETECTION":
                return CompetitionMetricSubCategory.OBJECT_DETECTION;
            case "COMPETITION_METRIC_SUB_CATEGORY_OTHER":
                return CompetitionMetricSubCategory.OTHER;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionMetricSubCategory.UNSPECIFIED:
            case 0:
            default:
                return "COMPETITION_METRIC_SUB_CATEGORY_UNSPECIFIED";
            case CompetitionMetricSubCategory.CLASSIFICATION:
            case 13302:
                return "COMPETITION_METRIC_SUB_CATEGORY_CLASSIFICATION";
            case CompetitionMetricSubCategory.REGRESSION:
            case 14203:
                return "COMPETITION_METRIC_SUB_CATEGORY_REGRESSION";
            case CompetitionMetricSubCategory.CLUSTERING:
            case 13304:
                return "COMPETITION_METRIC_SUB_CATEGORY_CLUSTERING";
            case CompetitionMetricSubCategory.OBJECT_DETECTION:
            case 17074:
                return "COMPETITION_METRIC_SUB_CATEGORY_OBJECT_DETECTION";
            case CompetitionMetricSubCategory.OTHER:
            case 16790:
                return "COMPETITION_METRIC_SUB_CATEGORY_OTHER";
        }
    }
};
export var CompetitionPrivacy;
(function(CompetitionPrivacy) {
    CompetitionPrivacy["UNSPECIFIED"] = "unspecified";
    CompetitionPrivacy["PUBLIC"] = "public";
    CompetitionPrivacy["LIMITED"] = "limited";
    CompetitionPrivacy["PRIVATE"] = "private";
})(CompetitionPrivacy || (CompetitionPrivacy = {}));
export var CompetitionPrivacyWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COMPETITION_PRIVACY_UNSPECIFIED":
            default:
                return CompetitionPrivacy.UNSPECIFIED;
            case "PUBLIC":
                return CompetitionPrivacy.PUBLIC;
            case "LIMITED":
                return CompetitionPrivacy.LIMITED;
            case "PRIVATE":
                return CompetitionPrivacy.PRIVATE;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CompetitionPrivacy.UNSPECIFIED:
            case 0:
            default:
                return "COMPETITION_PRIVACY_UNSPECIFIED";
            case CompetitionPrivacy.PUBLIC:
            case 1:
                return "PUBLIC";
            case CompetitionPrivacy.LIMITED:
            case 2:
                return "LIMITED";
            case CompetitionPrivacy.PRIVATE:
            case 3:
                return "PRIVATE";
        }
    }
};
export var EnvironmentRenderType;
(function(EnvironmentRenderType) {
    EnvironmentRenderType["UNSPECIFIED"] = "unspecified";
    EnvironmentRenderType["JSON"] = "json";
    EnvironmentRenderType[// Generate .html file from episode json
    "HTML"] = "html";
    EnvironmentRenderType[// Generate .webm file from episode json
    "VIDEO"] = "video";
    EnvironmentRenderType[// Generate .webm file and episode json simultaneously during the episode run
    "LIVE_VIDEO"] = "liveVideo";
})(EnvironmentRenderType || (EnvironmentRenderType = {}));
export var EnvironmentRenderTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ENVIRONMENT_RENDER_TYPE_UNSPECIFIED":
            default:
                return EnvironmentRenderType.UNSPECIFIED;
            case "ENVIRONMENT_RENDER_TYPE_JSON":
                return EnvironmentRenderType.JSON;
            case "ENVIRONMENT_RENDER_TYPE_HTML":
                return EnvironmentRenderType.HTML;
            case "ENVIRONMENT_RENDER_TYPE_VIDEO":
                return EnvironmentRenderType.VIDEO;
            case "ENVIRONMENT_RENDER_TYPE_LIVE_VIDEO":
                return EnvironmentRenderType.LIVE_VIDEO;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case EnvironmentRenderType.UNSPECIFIED:
            case 0:
            default:
                return "ENVIRONMENT_RENDER_TYPE_UNSPECIFIED";
            case EnvironmentRenderType.JSON:
            case 1:
                return "ENVIRONMENT_RENDER_TYPE_JSON";
            case EnvironmentRenderType.HTML:
            case 2:
                return "ENVIRONMENT_RENDER_TYPE_HTML";
            case EnvironmentRenderType.VIDEO:
            case 3:
                return "ENVIRONMENT_RENDER_TYPE_VIDEO";
            case EnvironmentRenderType.LIVE_VIDEO:
            case 4:
                return "ENVIRONMENT_RENDER_TYPE_LIVE_VIDEO";
        }
    }
};
export var EpisodeType;
(function(EpisodeType) {
    EpisodeType["UNSPECIFIED"] = "unspecified";
    EpisodeType["PUBLIC"] = "public";
    EpisodeType[// This is deprecated / was never supported.
    "PRIVATE"] = "private";
    EpisodeType["EXHIBITION"] = "exhibition";
    EpisodeType["VALIDATION"] = "validation";
})(EpisodeType || (EpisodeType = {}));
export var EpisodeTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EPISODE_TYPE_UNSPECIFIED":
            default:
                return EpisodeType.UNSPECIFIED;
            case "EPISODE_TYPE_PUBLIC":
                return EpisodeType.PUBLIC;
            case "EPISODE_TYPE_PRIVATE":
                return EpisodeType.PRIVATE;
            case "EPISODE_TYPE_EXHIBITION":
                return EpisodeType.EXHIBITION;
            case "EPISODE_TYPE_VALIDATION":
                return EpisodeType.VALIDATION;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case EpisodeType.UNSPECIFIED:
            case 0:
            default:
                return "EPISODE_TYPE_UNSPECIFIED";
            case EpisodeType.PUBLIC:
            case 1:
                return "EPISODE_TYPE_PUBLIC";
            case EpisodeType.PRIVATE:
            case 2:
                return "EPISODE_TYPE_PRIVATE";
            case EpisodeType.EXHIBITION:
            case 3:
                return "EPISODE_TYPE_EXHIBITION";
            case EpisodeType.VALIDATION:
            case 4:
                return "EPISODE_TYPE_VALIDATION";
        }
    }
};
export var EvaluationAlgorithmState;
(function(EvaluationAlgorithmState) {
    EvaluationAlgorithmState["UNSPECIFIED"] = "unspecified";
    EvaluationAlgorithmState[// Metrics which do not yet have a validated version.
    "DRAFT"] = "draft";
    EvaluationAlgorithmState[// Metrics which have at least one validated version and are available for use
    "AVAILABLE"] = "available";
    EvaluationAlgorithmState[// Metrics which have a high enough failure rate that they should be unavailable for additional competitions
    "BANNED"] = "banned";
    EvaluationAlgorithmState[// Metrics which cannot be added to any new competitions but remain in use for existing deployments
    "DEPRECATED"] = "deprecated";
    EvaluationAlgorithmState[// C# metrics which are evaluated on the Comps Worker
    "LEGACY"] = "legacy";
    EvaluationAlgorithmState[// Environment (Simulations) metrics
    "ENVIRONMENT"] = "environment";
    EvaluationAlgorithmState[// Metrics that have had their source Kernel deleted.
    "DELETED"] = "deleted";
})(EvaluationAlgorithmState || (EvaluationAlgorithmState = {}));
export var EvaluationAlgorithmStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "EVALUATION_ALGORITHM_STATE_UNSPECIFIED":
            default:
                return EvaluationAlgorithmState.UNSPECIFIED;
            case "DRAFT":
                return EvaluationAlgorithmState.DRAFT;
            case "AVAILABLE":
                return EvaluationAlgorithmState.AVAILABLE;
            case "BANNED":
                return EvaluationAlgorithmState.BANNED;
            case "DEPRECATED":
                return EvaluationAlgorithmState.DEPRECATED;
            case "LEGACY":
                return EvaluationAlgorithmState.LEGACY;
            case "ENVIRONMENT":
                return EvaluationAlgorithmState.ENVIRONMENT;
            case "DELETED":
                return EvaluationAlgorithmState.DELETED;
        }
    }
};
export var HostSegment;
(function(HostSegment) {
    HostSegment["UNSPECIFIED"] = "unspecified";
    HostSegment["DATASETS"] = "datasets";
    HostSegment["FEATURED"] = "featured";
    HostSegment["GE_QUESTS"] = "geQuests";
    HostSegment["GETTING_STARTED"] = "gettingStarted";
    HostSegment["MASTERS"] = "masters";
    HostSegment["PLAYGROUND"] = "playground";
    HostSegment["PROSPECT"] = "prospect";
    HostSegment["RECRUITMENT"] = "recruitment";
    HostSegment["RESEARCH"] = "research";
    HostSegment["IN_CLASS"] = "inClass";
    HostSegment["ANALYTICS"] = "analytics";
})(HostSegment || (HostSegment = {}));
export var HostSegmentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "HOST_SEGMENT_UNSPECIFIED":
            default:
                return HostSegment.UNSPECIFIED;
            case "HOST_SEGMENT_DATASETS":
                return HostSegment.DATASETS;
            case "HOST_SEGMENT_FEATURED":
                return HostSegment.FEATURED;
            case "HOST_SEGMENT_GE_QUESTS":
                return HostSegment.GE_QUESTS;
            case "HOST_SEGMENT_GETTING_STARTED":
                return HostSegment.GETTING_STARTED;
            case "HOST_SEGMENT_MASTERS":
                return HostSegment.MASTERS;
            case "HOST_SEGMENT_PLAYGROUND":
                return HostSegment.PLAYGROUND;
            case "HOST_SEGMENT_PROSPECT":
                return HostSegment.PROSPECT;
            case "HOST_SEGMENT_RECRUITMENT":
                return HostSegment.RECRUITMENT;
            case "HOST_SEGMENT_RESEARCH":
                return HostSegment.RESEARCH;
            case "HOST_SEGMENT_IN_CLASS":
                return HostSegment.IN_CLASS;
            case "HOST_SEGMENT_ANALYTICS":
                return HostSegment.ANALYTICS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case HostSegment.UNSPECIFIED:
            case 0:
            default:
                return "HOST_SEGMENT_UNSPECIFIED";
            case HostSegment.DATASETS:
            case 9:
                return "HOST_SEGMENT_DATASETS";
            case HostSegment.FEATURED:
            case 1:
                return "HOST_SEGMENT_FEATURED";
            case HostSegment.GE_QUESTS:
            case 7:
                return "HOST_SEGMENT_GE_QUESTS";
            case HostSegment.GETTING_STARTED:
            case 5:
                return "HOST_SEGMENT_GETTING_STARTED";
            case HostSegment.MASTERS:
            case 6:
                return "HOST_SEGMENT_MASTERS";
            case HostSegment.PLAYGROUND:
            case 8:
                return "HOST_SEGMENT_PLAYGROUND";
            case HostSegment.PROSPECT:
            case 4:
                return "HOST_SEGMENT_PROSPECT";
            case HostSegment.RECRUITMENT:
            case 3:
                return "HOST_SEGMENT_RECRUITMENT";
            case HostSegment.RESEARCH:
            case 2:
                return "HOST_SEGMENT_RESEARCH";
            case HostSegment.IN_CLASS:
            case 10:
                return "HOST_SEGMENT_IN_CLASS";
            case HostSegment.ANALYTICS:
            case 11:
                return "HOST_SEGMENT_ANALYTICS";
        }
    }
};
export var LeaderboardMode;
(function(LeaderboardMode) {
    LeaderboardMode[// Default indicates to decide between Weak or Strong based on the
    // competition's current state.
    // For read operations like GetLeaderboard and GetRanksForUsers, Strong is
    // used if the competition is completed, private LB is visible, and
    // Strong LB has been written; otherwise Weak is used.
    // RecalculateLeaderboard will do the full Strong LB generation (in addition
    // to Weak) if the comp is completed, otherwise Weak.
    "DEFAULT"] = "default";
    LeaderboardMode[// Weak Leaderboard means it only uses localized caching of the best public
    // submission per team, stored in the Teams.PublicLeaderboard[SubmissionId,
    // Score, Date] fields (note -Rank is not used).
    // These fields should be kept current synchronously as the comp
    // progresses, along with Teams' SubmissionCount and LastSubmissionDate
    // fields.
    // GetLeaderboard in Weak mode will use the cached data to efficiently get
    // the public LB.  The private LB, which should only be available to admins
    // while Weak is the default, will require a more expensive full calculation.
    // RecalculateLeaderboard in Weak mode will recalculate the Team-localized
    // cached data described above, although ideally those fields are kept in
    // sync already.
    "WEAK"] = "weak";
    LeaderboardMode[// Strong Leaderboard caches full information about both public and private
    // LBs within the Teams table, including competition-wide Ranks.
    // These fields are only written by RecalculateLeaderboard, which can be
    // invoked manually by admins, or by a forthcoming ScheduledHandler which
    // looks for Competitions which have ended but haven't calculated their
    // Strong Leaderboard.
    // We track whether a Competition has calculated its Strong Leaderboard via
    // Competitions.LeaderboardCacheDate field.
    // GetLeaderboard in Strong mode will be able to get Public and Private LBs
    // efficiently for all users.
    "STRONG"] = "strong";
})(LeaderboardMode || (LeaderboardMode = {}));
export var LeaderboardModeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case LeaderboardMode.DEFAULT:
            case 0:
            default:
                return "LEADERBOARD_MODE_DEFAULT";
            case LeaderboardMode.WEAK:
            case 1:
                return "LEADERBOARD_MODE_WEAK";
            case LeaderboardMode.STRONG:
            case 2:
                return "LEADERBOARD_MODE_STRONG";
        }
    }
};
export var MetricLanguage;
(function(MetricLanguage) {
    MetricLanguage["UNSPECIFIED"] = "unspecified";
    MetricLanguage["C_SHARP"] = "cSharp";
    MetricLanguage["PYTHON"] = "python";
})(MetricLanguage || (MetricLanguage = {}));
export var MetricLanguageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "METRIC_LANGUAGE_UNSPECIFIED":
            default:
                return MetricLanguage.UNSPECIFIED;
            case "METRIC_LANGUAGE_C_SHARP":
                return MetricLanguage.C_SHARP;
            case "METRIC_LANGUAGE_PYTHON":
                return MetricLanguage.PYTHON;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case MetricLanguage.UNSPECIFIED:
            case 0:
            default:
                return "METRIC_LANGUAGE_UNSPECIFIED";
            case MetricLanguage.C_SHARP:
            case 1:
                return "METRIC_LANGUAGE_C_SHARP";
            case MetricLanguage.PYTHON:
            case 2:
                return "METRIC_LANGUAGE_PYTHON";
        }
    }
};
export var MetricListAuthorType;
(function(MetricListAuthorType) {
    MetricListAuthorType["UNSPECIFIED"] = "unspecified";
    MetricListAuthorType["KAGGLE"] = "kaggle";
    MetricListAuthorType["OWN"] = "own";
    MetricListAuthorType["SHARED"] = "shared";
})(MetricListAuthorType || (MetricListAuthorType = {}));
export var MetricListAuthorTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case MetricListAuthorType.UNSPECIFIED:
            case 0:
            default:
                return "METRIC_LIST_AUTHOR_TYPE_UNSPECIFIED";
            case MetricListAuthorType.KAGGLE:
            case 1:
                return "METRIC_LIST_AUTHOR_TYPE_KAGGLE";
            case MetricListAuthorType.OWN:
            case 2:
                return "METRIC_LIST_AUTHOR_TYPE_OWN";
            case MetricListAuthorType.SHARED:
            case 3:
                return "METRIC_LIST_AUTHOR_TYPE_SHARED";
        }
    }
};
export var MetricListSortType;
(function(MetricListSortType) {
    MetricListSortType["UNSPECIFIED"] = "unspecified";
    MetricListSortType["NAME_ASC"] = "nameAsc";
    MetricListSortType["NAME_DESC"] = "nameDesc";
})(MetricListSortType || (MetricListSortType = {}));
export var MetricListSortTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case MetricListSortType.UNSPECIFIED:
            case 0:
            default:
                return "METRIC_LIST_SORT_TYPE_UNSPECIFIED";
            case MetricListSortType.NAME_ASC:
            case 1:
                return "METRIC_LIST_SORT_TYPE_NAME_ASC";
            case MetricListSortType.NAME_DESC:
            case 2:
                return "METRIC_LIST_SORT_TYPE_NAME_DESC";
        }
    }
};
export var ParticipationLevel;
(function(ParticipationLevel) {
    ParticipationLevel["UNSPECIFIED"] = "unspecified";
    ParticipationLevel["ANYONE"] = "anyone";
    ParticipationLevel["LINK"] = "link";
    ParticipationLevel["EMAIL_LIST"] = "emailList";
})(ParticipationLevel || (ParticipationLevel = {}));
export var PubliclyCloneable;
(function(PubliclyCloneable) {
    PubliclyCloneable[// not cloneable
    "UNSPECIFIED"] = "unspecified";
    PubliclyCloneable[// publicly cloneable - cloning this competition will NOT give you access to solution file
    "WITH_PRIVATE_SOLUTION_FILE"] = "withPrivateSolutionFile";
    PubliclyCloneable[// publicly cloneable - cloning this competition will give you access to the solution file
    "WITH_PUBLIC_SOLUTION_FILE"] = "withPublicSolutionFile";
})(PubliclyCloneable || (PubliclyCloneable = {}));
export var PubliclyCloneableWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "PUBLICLY_CLONEABLE_UNSPECIFIED":
            default:
                return PubliclyCloneable.UNSPECIFIED;
            case "PUBLICLY_CLONEABLE_WITH_PRIVATE_SOLUTION_FILE":
                return PubliclyCloneable.WITH_PRIVATE_SOLUTION_FILE;
            case "PUBLICLY_CLONEABLE_WITH_PUBLIC_SOLUTION_FILE":
                return PubliclyCloneable.WITH_PUBLIC_SOLUTION_FILE;
        }
    }
};
export var RerunState;
(function(RerunState) {
    RerunState["UNSPECIFIED"] = "unspecified";
    RerunState["INITIATED"] = "initiated";
    RerunState["KERNEL_RUN_QUEUED"] = "kernelRunQueued";
    RerunState["KERNEL_RUN_RUNNING"] = "kernelRunRunning";
    RerunState["KERNEL_RUN_FAILED_TO_START"] = "kernelRunFailedToStart";
    RerunState["KERNEL_RUN_OUT_OF_MEMORY"] = "kernelRunOutOfMemory";
    RerunState["KERNEL_RUN_OUT_OF_DISK"] = "kernelRunOutOfDisk";
    RerunState["KERNEL_RUN_TIMEOUT"] = "kernelRunTimeout";
    RerunState["SUBMISSION_RUNNING"] = "submissionRunning";
    RerunState["SUBMISSION_CSV_NOT_FOUND"] = "submissionCsvNotFound";
    RerunState["SUBMISSION_FAILED_TO_START"] = "submissionFailedToStart";
    RerunState["SUBMISSION_GENERIC_FAILURE"] = "submissionGenericFailure";
    RerunState["SUBMISSION_SUCCEEDED"] = "submissionSucceeded";
    RerunState["PUBLISHED"] = "published";
    RerunState["KERNEL_RUN_CANCELLED"] = "kernelRunCancelled";
    RerunState["KERNEL_RUN_UNKNOWN_ERROR"] = "kernelRunUnknownError";
    RerunState["SUBMISSION_UNKNOWN_ERROR"] = "submissionUnknownError";
    RerunState["KERNEL_RUN_KILLED"] = "kernelRunKilled";
    RerunState["KERNEL_RUN_LIKELY_USER_CODE_ERROR"] = "kernelRunLikelyUserCodeError";
    RerunState["KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS"] = "kernelRunViolatedComputeConstraints";
    RerunState["KERNEL_RUN_REAPED"] = "kernelRunReaped";
    RerunState["SUBMISSION_REAPED"] = "submissionReaped";
    RerunState["SUBMISSION_FAILED_TO_PUBLISH"] = "submissionFailedToPublish";
    RerunState["KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED"] = "kernelRunMaxOutputFilesExceeded";
    RerunState["KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT"] = "kernelRunAbortedForSubmissionLimit";
    RerunState["KERNEL_RUN_NOT_FOUND"] = "kernelRunNotFound";
})(RerunState || (RerunState = {}));
export var RerunStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RERUN_STATE_UNSPECIFIED":
            default:
                return RerunState.UNSPECIFIED;
            case "INITIATED":
                return RerunState.INITIATED;
            case "KERNEL_RUN_QUEUED":
                return RerunState.KERNEL_RUN_QUEUED;
            case "KERNEL_RUN_RUNNING":
                return RerunState.KERNEL_RUN_RUNNING;
            case "KERNEL_RUN_FAILED_TO_START":
                return RerunState.KERNEL_RUN_FAILED_TO_START;
            case "KERNEL_RUN_OUT_OF_MEMORY":
                return RerunState.KERNEL_RUN_OUT_OF_MEMORY;
            case "KERNEL_RUN_OUT_OF_DISK":
                return RerunState.KERNEL_RUN_OUT_OF_DISK;
            case "KERNEL_RUN_TIMEOUT":
                return RerunState.KERNEL_RUN_TIMEOUT;
            case "SUBMISSION_RUNNING":
                return RerunState.SUBMISSION_RUNNING;
            case "SUBMISSION_CSV_NOT_FOUND":
                return RerunState.SUBMISSION_CSV_NOT_FOUND;
            case "SUBMISSION_FAILED_TO_START":
                return RerunState.SUBMISSION_FAILED_TO_START;
            case "SUBMISSION_GENERIC_FAILURE":
                return RerunState.SUBMISSION_GENERIC_FAILURE;
            case "SUBMISSION_SUCCEEDED":
                return RerunState.SUBMISSION_SUCCEEDED;
            case "PUBLISHED":
                return RerunState.PUBLISHED;
            case "KERNEL_RUN_CANCELLED":
                return RerunState.KERNEL_RUN_CANCELLED;
            case "KERNEL_RUN_UNKNOWN_ERROR":
                return RerunState.KERNEL_RUN_UNKNOWN_ERROR;
            case "SUBMISSION_UNKNOWN_ERROR":
                return RerunState.SUBMISSION_UNKNOWN_ERROR;
            case "KERNEL_RUN_KILLED":
                return RerunState.KERNEL_RUN_KILLED;
            case "KERNEL_RUN_LIKELY_USER_CODE_ERROR":
                return RerunState.KERNEL_RUN_LIKELY_USER_CODE_ERROR;
            case "KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS":
                return RerunState.KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS;
            case "KERNEL_RUN_REAPED":
                return RerunState.KERNEL_RUN_REAPED;
            case "SUBMISSION_REAPED":
                return RerunState.SUBMISSION_REAPED;
            case "SUBMISSION_FAILED_TO_PUBLISH":
                return RerunState.SUBMISSION_FAILED_TO_PUBLISH;
            case "KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED":
                return RerunState.KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED;
            case "KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT":
                return RerunState.KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT;
            case "KERNEL_RUN_NOT_FOUND":
                return RerunState.KERNEL_RUN_NOT_FOUND;
        }
    }
};
export var RerunStateErrorCause;
(function(RerunStateErrorCause) {
    RerunStateErrorCause[// This can be used for non-error states and is a reasonable default.
    "NONE"] = "none";
    RerunStateErrorCause[// This is a real value used for error states.
    "UNKNOWN"] = "unknown";
    RerunStateErrorCause["KERNEL_RUN_FAILED_TO_START"] = "kernelRunFailedToStart";
    RerunStateErrorCause["KERNEL_RUN_OUT_OF_MEMORY"] = "kernelRunOutOfMemory";
    RerunStateErrorCause["KERNEL_RUN_OUT_OF_DISK"] = "kernelRunOutOfDisk";
    RerunStateErrorCause["KERNEL_RUN_TIMEOUT"] = "kernelRunTimeout";
    RerunStateErrorCause["KERNEL_RUN_KILLED"] = "kernelRunKilled";
    RerunStateErrorCause["KERNEL_RUN_LIKELY_USER_CODE_ERROR"] = "kernelRunLikelyUserCodeError";
    RerunStateErrorCause["KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS"] = "kernelRunViolatedComputeConstraints";
    RerunStateErrorCause["KERNEL_RUN_REAPED"] = "kernelRunReaped";
    RerunStateErrorCause["SUBMISSION_CSV_NOT_FOUND"] = "submissionCsvNotFound";
    RerunStateErrorCause["SUBMISSION_FAILED_TO_START"] = "submissionFailedToStart";
    RerunStateErrorCause["SUBMISSION_GENERIC_FAILURE"] = "submissionGenericFailure";
    RerunStateErrorCause["SUBMISSION_REAPED"] = "submissionReaped";
    RerunStateErrorCause["SUBMISSION_FAILED_TO_PUBLISH"] = "submissionFailedToPublish";
    RerunStateErrorCause["KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED"] = "kernelRunMaxOutputFilesExceeded";
    RerunStateErrorCause["KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT"] = "kernelRunAbortedForSubmissionLimit";
    RerunStateErrorCause["KERNEL_RUN_NOT_FOUND"] = "kernelRunNotFound";
})(RerunStateErrorCause || (RerunStateErrorCause = {}));
export var RerunStateErrorCauseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RERUN_STATE_ERROR_CAUSE_NONE":
            default:
                return RerunStateErrorCause.NONE;
            case "RERUN_STATE_ERROR_CAUSE_UNKNOWN":
                return RerunStateErrorCause.UNKNOWN;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_FAILED_TO_START":
                return RerunStateErrorCause.KERNEL_RUN_FAILED_TO_START;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_OUT_OF_MEMORY":
                return RerunStateErrorCause.KERNEL_RUN_OUT_OF_MEMORY;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_OUT_OF_DISK":
                return RerunStateErrorCause.KERNEL_RUN_OUT_OF_DISK;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_TIMEOUT":
                return RerunStateErrorCause.KERNEL_RUN_TIMEOUT;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_KILLED":
                return RerunStateErrorCause.KERNEL_RUN_KILLED;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_LIKELY_USER_CODE_ERROR":
                return RerunStateErrorCause.KERNEL_RUN_LIKELY_USER_CODE_ERROR;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS":
                return RerunStateErrorCause.KERNEL_RUN_VIOLATED_COMPUTE_CONSTRAINTS;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_REAPED":
                return RerunStateErrorCause.KERNEL_RUN_REAPED;
            case "RERUN_STATE_ERROR_CAUSE_SUBMISSION_CSV_NOT_FOUND":
                return RerunStateErrorCause.SUBMISSION_CSV_NOT_FOUND;
            case "RERUN_STATE_ERROR_CAUSE_SUBMISSION_FAILED_TO_START":
                return RerunStateErrorCause.SUBMISSION_FAILED_TO_START;
            case "RERUN_STATE_ERROR_CAUSE_SUBMISSION_GENERIC_FAILURE":
                return RerunStateErrorCause.SUBMISSION_GENERIC_FAILURE;
            case "RERUN_STATE_ERROR_CAUSE_SUBMISSION_REAPED":
                return RerunStateErrorCause.SUBMISSION_REAPED;
            case "RERUN_STATE_ERROR_CAUSE_SUBMISSION_FAILED_TO_PUBLISH":
                return RerunStateErrorCause.SUBMISSION_FAILED_TO_PUBLISH;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED":
                return RerunStateErrorCause.KERNEL_RUN_MAX_OUTPUT_FILES_EXCEEDED;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT":
                return RerunStateErrorCause.KERNEL_RUN_ABORTED_FOR_SUBMISSION_LIMIT;
            case "RERUN_STATE_ERROR_CAUSE_KERNEL_RUN_NOT_FOUND":
                return RerunStateErrorCause.KERNEL_RUN_NOT_FOUND;
        }
    }
};
export var RerunStateName;
(function(RerunStateName) {
    RerunStateName[// Should never actually be used, but best practice for proto enum.
    "UNSPECIFIED"] = "unspecified";
    RerunStateName["INITIATED"] = "initiated";
    RerunStateName["KERNEL_RUN_QUEUED"] = "kernelRunQueued";
    RerunStateName["KERNEL_RUN_RUNNING"] = "kernelRunRunning";
    RerunStateName["KERNEL_RUN_ERROR"] = "kernelRunError";
    RerunStateName["SUBMISSION_RUNNING"] = "submissionRunning";
    RerunStateName["SUBMISSION_ERROR"] = "submissionError";
    RerunStateName["SUBMISSION_SUCCEEDED"] = "submissionSucceeded";
    RerunStateName["PUBLISHED"] = "published";
    RerunStateName["KERNEL_RUN_CANCELLED"] = "kernelRunCancelled";
})(RerunStateName || (RerunStateName = {}));
export var RerunStateNameWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RERUN_STATE_NAME_UNSPECIFIED":
            default:
                return RerunStateName.UNSPECIFIED;
            case "RERUN_STATE_NAME_INITIATED":
                return RerunStateName.INITIATED;
            case "RERUN_STATE_NAME_KERNEL_RUN_QUEUED":
                return RerunStateName.KERNEL_RUN_QUEUED;
            case "RERUN_STATE_NAME_KERNEL_RUN_RUNNING":
                return RerunStateName.KERNEL_RUN_RUNNING;
            case "RERUN_STATE_NAME_KERNEL_RUN_ERROR":
                return RerunStateName.KERNEL_RUN_ERROR;
            case "RERUN_STATE_NAME_SUBMISSION_RUNNING":
                return RerunStateName.SUBMISSION_RUNNING;
            case "RERUN_STATE_NAME_SUBMISSION_ERROR":
                return RerunStateName.SUBMISSION_ERROR;
            case "RERUN_STATE_NAME_SUBMISSION_SUCCEEDED":
                return RerunStateName.SUBMISSION_SUCCEEDED;
            case "RERUN_STATE_NAME_PUBLISHED":
                return RerunStateName.PUBLISHED;
            case "RERUN_STATE_NAME_KERNEL_RUN_CANCELLED":
                return RerunStateName.KERNEL_RUN_CANCELLED;
        }
    }
};
export var RescoreState;
(function(RescoreState) {
    RescoreState["UNSPECIFIED"] = "unspecified";
    RescoreState["INITIATED"] = "initiated";
    RescoreState["SCORING"] = "scoring";
    RescoreState["SUBMISSION_ERROR"] = "submissionError";
    RescoreState["SUCCEEDED"] = "succeeded";
    RescoreState["CANCELED"] = "canceled";
    RescoreState["PROCESSING_ERROR"] = "processingError";
})(RescoreState || (RescoreState = {}));
export var RescoreStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "RESCORE_STATE_UNSPECIFIED":
            default:
                return RescoreState.UNSPECIFIED;
            case "RESCORE_STATE_INITIATED":
                return RescoreState.INITIATED;
            case "RESCORE_STATE_SCORING":
                return RescoreState.SCORING;
            case "RESCORE_STATE_SUBMISSION_ERROR":
                return RescoreState.SUBMISSION_ERROR;
            case "RESCORE_STATE_SUCCEEDED":
                return RescoreState.SUCCEEDED;
            case "RESCORE_STATE_CANCELED":
                return RescoreState.CANCELED;
            case "RESCORE_STATE_PROCESSING_ERROR":
                return RescoreState.PROCESSING_ERROR;
        }
    }
};
export var RescoreType;
(function(RescoreType) {
    RescoreType["UNSPECIFIED"] = "unspecified";
    RescoreType["ALL"] = "all";
    RescoreType["PENDING"] = "pending";
    RescoreType["ERRORED"] = "errored";
    RescoreType["COMPLETED"] = "completed";
    RescoreType["BULK_RERUN"] = "bulkRerun";
    RescoreType["MANUAL"] = "manual";
})(RescoreType || (RescoreType = {}));
export var RescoreTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case RescoreType.UNSPECIFIED:
            case 0:
            default:
                return "RESCORE_TYPE_UNSPECIFIED";
            case RescoreType.ALL:
            case 1:
                return "RESCORE_TYPE_ALL";
            case RescoreType.PENDING:
            case 2:
                return "RESCORE_TYPE_PENDING";
            case RescoreType.ERRORED:
            case 3:
                return "RESCORE_TYPE_ERRORED";
            case RescoreType.COMPLETED:
            case 4:
                return "RESCORE_TYPE_COMPLETED";
            case RescoreType.BULK_RERUN:
            case 5:
                return "RESCORE_TYPE_BULK_RERUN";
            case RescoreType.MANUAL:
            case 6:
                return "RESCORE_TYPE_MANUAL";
        }
    }
};
export var SubmissionGroup;
(function(SubmissionGroup) {
    SubmissionGroup["ALL"] = "all";
    SubmissionGroup["SUCCESSFUL"] = "successful";
    SubmissionGroup["SELECTED"] = "selected";
})(SubmissionGroup || (SubmissionGroup = {}));
export var SubmissionGroupWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SubmissionGroup.ALL:
            case 0:
            default:
                return "SUBMISSION_GROUP_ALL";
            case SubmissionGroup.SUCCESSFUL:
            case 1:
                return "SUBMISSION_GROUP_SUCCESSFUL";
            case SubmissionGroup.SELECTED:
            case 2:
                return "SUBMISSION_GROUP_SELECTED";
        }
    }
};
export var SubmissionNotAllowedReasonCode;
(function(SubmissionNotAllowedReasonCode) {
    SubmissionNotAllowedReasonCode["UNSPECIFIED"] = "unspecified";
    SubmissionNotAllowedReasonCode[// The Comp has disabled submissions.
    "COMPETITION_DISABLED"] = "competitionDisabled";
    SubmissionNotAllowedReasonCode[// Current User did not have Team in given comp.
    "TEAM_NOT_FOUND"] = "teamNotFound";
    SubmissionNotAllowedReasonCode[// Checks the Current User's Team's Daily/Global Submission allowance.
    "TEAM_ALLOWANCE_EXCEEDED"] = "teamAllowanceExceeded";
    SubmissionNotAllowedReasonCode["KERNEL_STILL_RUNNING"] = "kernelStillRunning";
    SubmissionNotAllowedReasonCode["KERNEL_RUNTIME_EXCEEDED"] = "kernelRuntimeExceeded";
    SubmissionNotAllowedReasonCode["MISSING_COMPETITION_DATASOURCE"] = "missingCompetitionDatasource";
    SubmissionNotAllowedReasonCode["HAS_OTHER_COMPETITION_DATASOURCE"] = "hasOtherCompetitionDatasource";
    SubmissionNotAllowedReasonCode["HAS_DATASET_DATASOURCE"] = "hasDatasetDatasource";
    SubmissionNotAllowedReasonCode["HAS_KERNEL_DATASOURCE"] = "hasKernelDatasource";
    SubmissionNotAllowedReasonCode["USES_GPU"] = "usesGpu";
    SubmissionNotAllowedReasonCode["USES_INTERNET"] = "usesInternet";
    SubmissionNotAllowedReasonCode["USES_CUSTOM_DOCKER_IMAGE"] = "usesCustomDockerImage";
    SubmissionNotAllowedReasonCode["INPUT_KERNEL_REJECTED"] = "inputKernelRejected";
    SubmissionNotAllowedReasonCode["WRONG_FILE_NAME"] = "wrongFileName";
    SubmissionNotAllowedReasonCode[// GetKernelRun() can fail if the Kernel was determined to be orphaned
    // and reaped.
    "KERNEL_READ_ERROR"] = "kernelReadError";
    SubmissionNotAllowedReasonCode["USES_TPU"] = "usesTpu";
    SubmissionNotAllowedReasonCode["USES_NON_STANDARD_DATASET"] = "usesNonStandardDataset";
    SubmissionNotAllowedReasonCode["DATASET_SIZE_EXCEEDED"] = "datasetSizeExceeded";
    SubmissionNotAllowedReasonCode["NOT_PYTHON"] = "notPython";
    SubmissionNotAllowedReasonCode["USES_NON_VERSIONED_DATASET"] = "usesNonVersionedDataset";
    SubmissionNotAllowedReasonCode["EVALUATION_NOT_SETUP"] = "evaluationNotSetup";
    SubmissionNotAllowedReasonCode["COMPETITION_NOT_LAUNCHED"] = "competitionNotLaunched";
    SubmissionNotAllowedReasonCode["KERNEL_USES_PAID_TIER"] = "kernelUsesPaidTier";
    SubmissionNotAllowedReasonCode["FILE_BLOB_NOT_FOUND"] = "fileBlobNotFound";
    SubmissionNotAllowedReasonCode["FILE_TOO_LARGE"] = "fileTooLarge";
    SubmissionNotAllowedReasonCode["KERNEL_FILE_NOT_FOUND"] = "kernelFileNotFound";
    SubmissionNotAllowedReasonCode["INCORRECT_SUBMISSION_TYPE"] = "incorrectSubmissionType";
    SubmissionNotAllowedReasonCode["NEW_ENTRANTS_DISABLED"] = "newEntrantsDisabled";
})(SubmissionNotAllowedReasonCode || (SubmissionNotAllowedReasonCode = {}));
export var SubmissionNotAllowedReasonCodeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_UNSPECIFIED":
            default:
                return SubmissionNotAllowedReasonCode.UNSPECIFIED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_COMPETITION_DISABLED":
                return SubmissionNotAllowedReasonCode.COMPETITION_DISABLED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_TEAM_NOT_FOUND":
                return SubmissionNotAllowedReasonCode.TEAM_NOT_FOUND;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_TEAM_ALLOWANCE_EXCEEDED":
                return SubmissionNotAllowedReasonCode.TEAM_ALLOWANCE_EXCEEDED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_KERNEL_STILL_RUNNING":
                return SubmissionNotAllowedReasonCode.KERNEL_STILL_RUNNING;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_KERNEL_RUNTIME_EXCEEDED":
                return SubmissionNotAllowedReasonCode.KERNEL_RUNTIME_EXCEEDED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_MISSING_COMPETITION_DATASOURCE":
                return SubmissionNotAllowedReasonCode.MISSING_COMPETITION_DATASOURCE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_HAS_OTHER_COMPETITION_DATASOURCE":
                return SubmissionNotAllowedReasonCode.HAS_OTHER_COMPETITION_DATASOURCE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_HAS_DATASET_DATASOURCE":
                return SubmissionNotAllowedReasonCode.HAS_DATASET_DATASOURCE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_HAS_KERNEL_DATASOURCE":
                return SubmissionNotAllowedReasonCode.HAS_KERNEL_DATASOURCE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_GPU":
                return SubmissionNotAllowedReasonCode.USES_GPU;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_INTERNET":
                return SubmissionNotAllowedReasonCode.USES_INTERNET;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_CUSTOM_DOCKER_IMAGE":
                return SubmissionNotAllowedReasonCode.USES_CUSTOM_DOCKER_IMAGE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_INPUT_KERNEL_REJECTED":
                return SubmissionNotAllowedReasonCode.INPUT_KERNEL_REJECTED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_WRONG_FILE_NAME":
                return SubmissionNotAllowedReasonCode.WRONG_FILE_NAME;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_KERNEL_READ_ERROR":
                return SubmissionNotAllowedReasonCode.KERNEL_READ_ERROR;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_TPU":
                return SubmissionNotAllowedReasonCode.USES_TPU;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_NON_STANDARD_DATASET":
                return SubmissionNotAllowedReasonCode.USES_NON_STANDARD_DATASET;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_DATASET_SIZE_EXCEEDED":
                return SubmissionNotAllowedReasonCode.DATASET_SIZE_EXCEEDED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_NOT_PYTHON":
                return SubmissionNotAllowedReasonCode.NOT_PYTHON;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_USES_NON_VERSIONED_DATASET":
                return SubmissionNotAllowedReasonCode.USES_NON_VERSIONED_DATASET;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_EVALUATION_NOT_SETUP":
                return SubmissionNotAllowedReasonCode.EVALUATION_NOT_SETUP;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_COMPETITION_NOT_LAUNCHED":
                return SubmissionNotAllowedReasonCode.COMPETITION_NOT_LAUNCHED;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_KERNEL_USES_PAID_TIER":
                return SubmissionNotAllowedReasonCode.KERNEL_USES_PAID_TIER;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_FILE_BLOB_NOT_FOUND":
                return SubmissionNotAllowedReasonCode.FILE_BLOB_NOT_FOUND;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_FILE_TOO_LARGE":
                return SubmissionNotAllowedReasonCode.FILE_TOO_LARGE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_KERNEL_FILE_NOT_FOUND":
                return SubmissionNotAllowedReasonCode.KERNEL_FILE_NOT_FOUND;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_INCORRECT_SUBMISSION_TYPE":
                return SubmissionNotAllowedReasonCode.INCORRECT_SUBMISSION_TYPE;
            case "SUBMISSION_NOT_ALLOWED_REASON_CODE_NEW_ENTRANTS_DISABLED":
                return SubmissionNotAllowedReasonCode.NEW_ENTRANTS_DISABLED;
        }
    }
};
export var SubmissionSortBy;
(function(SubmissionSortBy) {
    SubmissionSortBy["DATE"] = "date";
    SubmissionSortBy["NAME"] = "name";
    SubmissionSortBy["PRIVATE_SCORE"] = "privateScore";
    SubmissionSortBy["PUBLIC_SCORE"] = "publicScore";
})(SubmissionSortBy || (SubmissionSortBy = {}));
export var SubmissionSortByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case SubmissionSortBy.DATE:
            case 0:
            default:
                return "SUBMISSION_SORT_BY_DATE";
            case SubmissionSortBy.NAME:
            case 1:
                return "SUBMISSION_SORT_BY_NAME";
            case SubmissionSortBy.PRIVATE_SCORE:
            case 2:
                return "SUBMISSION_SORT_BY_PRIVATE_SCORE";
            case SubmissionSortBy.PUBLIC_SCORE:
            case 3:
                return "SUBMISSION_SORT_BY_PUBLIC_SCORE";
        }
    }
};
export var SubmissionStatus;
(function(SubmissionStatus) {
    SubmissionStatus["PENDING"] = "pending";
    SubmissionStatus["COMPLETE"] = "complete";
    SubmissionStatus["ERROR"] = "error";
})(SubmissionStatus || (SubmissionStatus = {}));
export var SubmissionStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "PENDING":
            default:
                return SubmissionStatus.PENDING;
            case "COMPLETE":
                return SubmissionStatus.COMPLETE;
            case "ERROR":
                return SubmissionStatus.ERROR;
        }
    }
};
export var TeamMergeRequestState;
(function(TeamMergeRequestState) {
    TeamMergeRequestState["UNSPECIFIED"] = "unspecified";
    TeamMergeRequestState["REQUESTED"] = "requested";
    TeamMergeRequestState["ACCEPTED"] = "accepted";
    TeamMergeRequestState["REJECTED"] = "rejected";
    TeamMergeRequestState["DEACTIVATED"] = "deactivated";
})(TeamMergeRequestState || (TeamMergeRequestState = {}));
export var TeamMergeRequestStateWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TEAM_MERGE_REQUEST_STATE_UNSPECIFIED":
            default:
                return TeamMergeRequestState.UNSPECIFIED;
            case "REQUESTED":
                return TeamMergeRequestState.REQUESTED;
            case "ACCEPTED":
                return TeamMergeRequestState.ACCEPTED;
            case "REJECTED":
                return TeamMergeRequestState.REJECTED;
            case "DEACTIVATED":
                return TeamMergeRequestState.DEACTIVATED;
        }
    }
};
export var UserFilter;
(function(UserFilter) {
    UserFilter["UNSPECIFIED"] = "unspecified";
    UserFilter["SUBMITTED"] = "submitted";
    UserFilter["SUBMITTED_NONE_SELECTED"] = "submittedNoneSelected";
    UserFilter["ACCEPTED_RULES"] = "acceptedRules";
    UserFilter["ACCEPTED_RULES_UNSUBMITTED"] = "acceptedRulesUnsubmitted";
})(UserFilter || (UserFilter = {}));
export var UserFilterWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case UserFilter.UNSPECIFIED:
            case 0:
            default:
                return "USER_FILTER_UNSPECIFIED";
            case UserFilter.SUBMITTED:
            case 1:
                return "USER_FILTER_SUBMITTED";
            case UserFilter.SUBMITTED_NONE_SELECTED:
            case 2:
                return "USER_FILTER_SUBMITTED_NONE_SELECTED";
            case UserFilter.ACCEPTED_RULES:
            case 3:
                return "USER_FILTER_ACCEPTED_RULES";
            case UserFilter.ACCEPTED_RULES_UNSUBMITTED:
            case 4:
                return "USER_FILTER_ACCEPTED_RULES_UNSUBMITTED";
        }
    }
};
// Competitions RPCs which only site admins can invoke. RPCs in other services may also be admin-only,
// this service is more of a catch-all for RPCs that don't have a more appropriate service home.
// Contains methods related to competitions.
// Contains methods related to hosting competitions.
// Contains methods related to competition leaderboards.
export var competitionsClient = {
    adminService: {
        // Emails participants in a competition that match criteria.
        emailParticipants: createClient(EmailParticipantsRequestWireFormat3, CompetitionEmailWireFormat3, "competitions.AdminService/EmailParticipants"),
        // Sets the competition deadline to now (ending the competition immediately).
        // Requestor must be Admin.
        setCompetitionDeadlineNow: createClient(SetCompetitionDeadlineNowRequestWireFormat3, SetCompetitionDeadlineNowResponseWireFormat3, "competitions.AdminService/SetCompetitionDeadlineNow")
    },
    competitionService: {
        // Gets information about the requested competition.
        getCompetition: createClient(GetCompetitionRequestWireFormat3, CompetitionWireFormat3, "competitions.CompetitionService/GetCompetition"),
        getCompetitionCitation: createClient(GetCompetitionCitationRequestWireFormat3, GetCompetitionCitationResponseWireFormat3, "competitions.CompetitionService/GetCompetitionCitation"),
        getCompetitionDatabundleVersion: createClient(GetCompetitionDatabundleVersionRequestWireFormat3, GetCompetitionDatabundleVersionResponseWireFormat3, "competitions.CompetitionService/GetCompetitionDatabundleVersion"),
        getCompetitions: createClient(GetCompetitionsRequestWireFormat3, GetCompetitionsResponseWireFormat3, "competitions.CompetitionService/GetCompetitions"),
        // Returns data used to create the "Competitions Summary" on a user profile's Competitions tab
        getProfileUserStats: createClient(GetProfileUserStatsRequestWireFormat3, GetProfileUserStatsResponseWireFormat3, "competitions.CompetitionService/GetProfileUserStats"),
        hasCompetitionEmailInvite: createClient(HasCompetitionEmailInviteRequestWireFormat3, HasCompetitionEmailInviteResponseWireFormat3, "competitions.CompetitionService/HasCompetitionEmailInvite"),
        // Lists the competitions according the query and sorting parameters
        // specified. Also includes information about the current user's team for each
        // competition.
        listCompetitions: createClient(ListCompetitionsRequestWireFormat3, ListCompetitionsResponseWireFormat3, "competitions.CompetitionService/ListCompetitions")
    },
    episodeService: {
        createEnvironmentMetric: createClient(CreateEnvironmentMetricRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.EpisodeService/CreateEnvironmentMetric"),
        // For each active Sims Comp, kick off some new Episodes.  Intended for use
        // by the GenerateEpisodesScheduledTask.
        generateEpisodes: createClient(GenerateEpisodesRequestWireFormat3, GenerateEpisodesResponseWireFormat3, "competitions.EpisodeService/GenerateEpisodes"),
        getEpisodeReplay: createRawStringClient(GetEpisodeReplayRequestWireFormat3, "competitions.EpisodeService/GetEpisodeReplay"),
        // Lists Episodes of type Completed for a given filter. Currently top 1000 only, by most recent EndTime.
        listEpisodes: createClient(ListEpisodesRequestWireFormat3, ListEpisodesResponseWireFormat3, "competitions.EpisodeService/ListEpisodes"),
        setEpisodeErrored: createClient(SetEpisodeErroredRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.EpisodeService/SetEpisodeErrored")
    },
    hostService: {
        // Creates a new (unlaunched) competition.
        // (-- aip.dev/not-precedent: Returning Competition wrapped in a Response)
        createCompetition: createClient(CreateCompetitionRequestWireFormat3, CreateCompetitionResponseWireFormat3, "competitions.HostService/CreateCompetition"),
        createCompetitionEmailInvite: createClient(CreateCompetitionEmailInvitesRequestWireFormat3, CreateCompetitionEmailInvitesResponseWireFormat3, "competitions.HostService/CreateCompetitionEmailInvite"),
        // Evaluation tab
        createCompetitionSampleSubmission: createClient(CreateCompetitionSampleSubmissionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.HostService/CreateCompetitionSampleSubmission"),
        createCompetitionSolution: createClient(CreateCompetitionSolutionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.HostService/CreateCompetitionSolution"),
        deleteCompetition: createClient(DeleteCompetitionRequestWireFormat3, DeleteCompetitionResponseWireFormat3, "competitions.HostService/DeleteCompetition"),
        deleteCompetitionEmailInvite: createClient(DeleteCompetitionEmailInviteRequestWireFormat3, DeleteCompetitionEmailInviteResponseWireFormat3, "competitions.HostService/DeleteCompetitionEmailInvite"),
        deleteSolutionFiles: createClient(DeleteSolutionFilesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.HostService/DeleteSolutionFiles"),
        // "Privacy" tab:
        getPrivacySettings: createClient(GetPrivacySettingsRequestWireFormat3, PrivacySettingsWireFormat3, "competitions.HostService/GetPrivacySettings"),
        listCompetitionEmailInvites: createClient(ListCompetitionEmailInvitesRequestWireFormat3, ListCompetitionEmailInvitesResponseWireFormat3, "competitions.HostService/ListCompetitionEmailInvites"),
        // This keeps existing UI behavior, but it could be refactored into the
        // UpdatePrivacySettings RPC above with a convention like setting it to "regenerate"
        // would cause it to be regenerated.
        regenerateShareToken: createClient(RegenerateShareTokenRequestWireFormat3, PrivacySettingsWireFormat3, "competitions.HostService/RegenerateShareToken"),
        setCompetitionMetric: createClient(SetCompetitionMetricRequestWireFormat3, SetCompetitionMetricResponseWireFormat3, "competitions.HostService/SetCompetitionMetric"),
        toggleBenchmarkSubmission: createClient(ToggleBenchmarkSubmissionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.HostService/ToggleBenchmarkSubmission"),
        updateCurrentCompetitionMetricVersion: createClient(UpdateCurrentCompetitionMetricVersionRequestWireFormat3, UpdateCurrentCompetitionMetricVersionResponseWireFormat3, "competitions.HostService/UpdateCurrentCompetitionMetricVersion"),
        updatePrivacySettings: createClient(UpdatePrivacySettingsRequestWireFormat3, PrivacySettingsWireFormat3, "competitions.HostService/UpdatePrivacySettings"),
        updateSandboxSubmissionName: createClient(UpdateSandboxSubmissionNameRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.HostService/UpdateSandboxSubmissionName"),
        waitForCompetitionAdminEvaluationEvent: createClient(WaitForCompetitionAdminEvaluationEventRequestWireFormat3, WaitForCompetitionAdminEvaluationEventResponseWireFormat3, "competitions.HostService/WaitForCompetitionAdminEvaluationEvent")
    },
    leaderboardService: {
        // Gets the leaderboard for the specified competition.
        getLeaderboard: createClient(GetLeaderboardRequestWireFormat3, GetLeaderboardResponseWireFormat3, "competitions.LeaderboardService/GetLeaderboard"),
        // Given a Competition and set of UserIds, returns each User's Team's Rank.
        // Uses the current main Leaderboard:  Public LB if comp is in Weak LB mode
        // (~= comp is ongoing), Private LB if comp is in Strong LB mode (and comp
        // has Private LB).  See LeaderboardMode enum below.
        getRanksForUsers: createClient(GetRanksForUsersRequestWireFormat3, GetRanksForUsersResponseWireFormat3, "competitions.LeaderboardService/GetRanksForUsers"),
        // Admin-only RPC that uses the legacy recalculate version of the above RPC.
        // NOTE: This RPC should be removed once the newer one is fully live.
        legacyRecalculateLeaderboard: createClient(LegacyRecalculateLeaderboardRequestWireFormat3, LegacyRecalculateLeaderboardResponseWireFormat3, "competitions.LeaderboardService/LegacyRecalculateLeaderboard"),
        // Admin-only RPC which recalculates cached LB data stored on Teams rows.
        // Can either recalculate only Weak LB fields, or both Weak and Strong.
        // NOTE: This is the only way for the Strong LB fields, such as Ranks, to be
        // written.
        // It is not intended for frequent usage; the Weak LB should be kept up-to-
        // date synchronously as the competition progresses.
        recalculateLeaderboard: createClient(RecalculateLeaderboardRequestWireFormat3, RecalculateLeaderboardResponseWireFormat3, "competitions.LeaderboardService/RecalculateLeaderboard")
    },
    metricService: {
        createCompetitionMetric: createClient(CreateCompetitionMetricRequestWireFormat3, CreateCompetitionMetricResponseWireFormat3, "competitions.MetricService/CreateCompetitionMetric"),
        // Supports the Metric tab of the Kernel Editor
        getCompetitionMetricMetadata: createClient(GetCompetitionMetricMetadataRequestWireFormat3, GetCompetitionMetricMetadataResponseWireFormat3, "competitions.MetricService/GetCompetitionMetricMetadata"),
        getCompetitionMetricVersion: createClient(GetCompetitionMetricVersionRequestWireFormat3, CompetitionMetricVersionWireFormat3, "competitions.MetricService/GetCompetitionMetricVersion"),
        listCompetitionMetrics: createClient(ListCompetitionMetricsRequestWireFormat3, ListCompetitionMetricsResponseWireFormat3, "competitions.MetricService/ListCompetitionMetrics"),
        // Supports saving changes on the Metric tab of the Kernel Editor
        updateCompetitionMetricMetadata: createClient(UpdateCompetitionMetricMetadataRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.MetricService/UpdateCompetitionMetricMetadata")
    },
    pageService: {
        createPage: createClient(CreatePageRequestWireFormat3, PageWireFormat3, "competitions.PageService/CreatePage"),
        deletePage: createClient(DeletePageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.PageService/DeletePage"),
        getPage: createClient(GetPageRequestWireFormat3, PageWireFormat3, "competitions.PageService/GetPage"),
        listPages: createClient(ListPagesRequestWireFormat3, ListPagesResponseWireFormat3, "competitions.PageService/ListPages"),
        updatePage: createClient(UpdatePageRequestWireFormat3, PageWireFormat3, "competitions.PageService/UpdatePage")
    },
    rerunService: {
        // Bulk Reruns
        cancelBulkRerun: createClient(CancelBulkRerunRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.RerunService/CancelBulkRerun"),
        initiateBulkRerun: createClient(InitiateBulkRerunRequestWireFormat3, InitiateBulkRerunResponseWireFormat3, "competitions.RerunService/InitiateBulkRerun"),
        listBulkReruns: createClient(ListBulkRerunsRequestWireFormat3, ListBulkRerunsResponseWireFormat3, "competitions.RerunService/ListBulkReruns"),
        publishBulkRerun: createClient(PublishBulkRerunRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.RerunService/PublishBulkRerun")
    },
    rescoreService: {
        cancelBulkRescore: createClient(CancelBulkRescoreRequestWireFormat3, CancelBulkRescoreResponseWireFormat3, "competitions.RescoreService/CancelBulkRescore"),
        initiateBulkRescore: createClient(InitiateBulkRescoreRequestWireFormat3, InitiateBulkRescoreResponseWireFormat3, "competitions.RescoreService/InitiateBulkRescore"),
        listBulkRescores: createClient(ListBulkRescoresRequestWireFormat3, ListBulkRescoresResponseWireFormat3, "competitions.RescoreService/ListBulkRescores"),
        // Endpoint for synchronous, one-off Rescores of a single Submission
        // Visible to competition hosts, admins (ignoring field permissions), and system accounts (ignoring
        // field permissions)
        rescoreSubmission: createClient(RescoreSubmissionRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.RescoreService/RescoreSubmission")
    },
    submissionService: {
        canSubmit: createClient(CanSubmitRequestWireFormat3, CanSubmitResponseWireFormat3, "competitions.SubmissionService/CanSubmit"),
        // Invalidates the entire leaderboard for a specified Competition.
        clearLeaderboardSubmissions: createClient(ClearLeaderboardSubmissionsRequestWireFormat3, ClearLeaderboardSubmissionsResponseWireFormat3, "competitions.SubmissionService/ClearLeaderboardSubmissions"),
        createSubmission: createClient(CreateSubmissionRequestWireFormat3, SubmissionWireFormat3, "competitions.SubmissionService/CreateSubmission"),
        getSubmission: createClient(GetSubmissionRequestWireFormat3, SubmissionWireFormat3, "competitions.SubmissionService/GetSubmission"),
        getSubmissionLimitInfo: createClient(GetSubmissionLimitInfoRequestWireFormat3, SubmissionLimitInfoWireFormat3, "competitions.SubmissionService/GetSubmissionLimitInfo"),
        // Used to bulk-invalidate particular submission ids.
        invalidateSubmissions: createClient(InvalidateSubmissionsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.SubmissionService/InvalidateSubmissions"),
        listSubmissions: createClient(ListSubmissionsRequestWireFormat3, ListSubmissionsResponseWireFormat3, "competitions.SubmissionService/ListSubmissions"),
        updateSubmissionDescription: createClient(UpdateSubmissionDescriptionRequestWireFormat3, SubmissionWireFormat3, "competitions.SubmissionService/UpdateSubmissionDescription"),
        updateSubmissionSelection: createClient(UpdateSubmissionSelectionRequestWireFormat3, UpdateSubmissionSelectionResponseWireFormat3, "competitions.SubmissionService/UpdateSubmissionSelection")
    },
    teamService: {
        acceptTeamMerge: createClient(AcceptTeamMergeRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.TeamService/AcceptTeamMerge"),
        createTeamModelFile: createClient(CreateTeamModelFileRequestWireFormat3, CreateTeamModelFileResponseWireFormat3, "competitions.TeamService/CreateTeamModelFile"),
        createTeams: createClient(CreateTeamsRequestWireFormat3, CreateTeamsResponseWireFormat3, "competitions.TeamService/CreateTeams"),
        // TODO(b/204171009): Use HTTP Get and redirect once file downloads are supported by frontend clients
        downloadTeamModelFile: createClient(DownloadTeamModelFileRequestWireFormat3, DownloadTeamModelFileResponseWireFormat3, "competitions.TeamService/DownloadTeamModelFile"),
        getTeam: createClient(GetTeamRequestWireFormat3, TeamWireFormat3, "competitions.TeamService/GetTeam"),
        getTeamModelFile: createClient(GetTeamModelFileRequestWireFormat3, TeamModelFileWireFormat3, "competitions.TeamService/GetTeamModelFile"),
        listTeamMergeRequests: createClient(ListTeamMergeRequestsRequestWireFormat3, ListTeamMergeRequestsResponseWireFormat3, "competitions.TeamService/ListTeamMergeRequests"),
        listTeams: createClient(ListTeamsRequestWireFormat3, ListTeamsResponseWireFormat3, "competitions.TeamService/ListTeams"),
        listTeamsByUser: createClient(ListTeamsByUserRequestWireFormat3, ListTeamsByUserResponseWireFormat3, "competitions.TeamService/ListTeamsByUser"),
        rejectTeamMerge: createClient(RejectTeamMergeRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.TeamService/RejectTeamMerge"),
        requestTeamMerge: createClient(RequestTeamMergeRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.TeamService/RequestTeamMerge"),
        // Searches TeamName by a prefix, and returns up to 100 matching teams ordered by length.
        searchTeams: createClient(SearchTeamsRequestWireFormat3, SearchTeamsResponseWireFormat3, "competitions.TeamService/SearchTeams"),
        updateTeam: createClient(UpdateTeamRequestWireFormat3, TeamWireFormat3, "competitions.TeamService/UpdateTeam")
    },
    userService: {
        // Logs that the Current User has accepted the rules for the given
        // Competition.
        acceptRules: createClient(AcceptRulesRequestWireFormat3, google.protobuf.EmptyWireFormat3, "competitions.UserService/AcceptRules"),
        // Returns information about the calling User in the context of the given
        // Competition.
        getUser: createClient(GetUserRequestWireFormat3, GetUserResponseWireFormat3, "competitions.UserService/GetUser"),
        // Returns whether the Current User has accepted the rules for the given
        // Competition. Returns true if the Competition does not require rules
        // acceptance.
        // TODO(b/246802676): Migrate callers to CompetitionService.CheckCompetitionsPermissions and delete this
        hasAcceptedRules: createClient(HasAcceptedRulesRequestWireFormat3, HasAcceptedRulesResponseWireFormat3, "competitions.UserService/HasAcceptedRules")
    }
};
